import constsMeta from './constsMeta';

const {
  REACT_APP_NATIVE_APP,
  REACT_APP_DESKTOP_APP,
  REACT_APP_TEST_ENV,
  REACT_APP_REST_SERVER,
  REACT_APP_N1_SERVER,
  REACT_APP_P1_SERVER,
  REACT_APP_WS_SERVER,
  REACT_APP_GOOGLE_IOS_ID,
  REACT_APP_GOOGLE_ANDROID_WEB_CLIENT_ID,
  REACT_APP_GOOGLE_ANDROID_CLIENT_ID,
  REACT_APP_ONE_SIGNAL_APP_ID,
  REACT_APP_ONE_SIGNAL_IOS_APP_ID,
  // REACT_APP_FACEBOOK_APP_ID,
  REACT_APP_CLIENT_PAGE,
  REACT_APP_EXPERT_PAGE,
  REACT_APP_MAJOR_APPVERSION,
  REACT_APP_MINOR_APPVERSION,
  REACT_APP_GIT_COMMIT,
  DeviceInfo,
  Platform,
  // REACT_APP_STRIPE_PUBLISHABLE_KEY,
} = constsMeta;
const nativeApp = Boolean(REACT_APP_NATIVE_APP !== 'false');
const testEnv = nativeApp
  ? Boolean(REACT_APP_TEST_ENV !== 'false')
  : Boolean(process.env.REACT_APP_TEST_ENV !== 'false');
const gitCommit = nativeApp
  ? REACT_APP_GIT_COMMIT
  : process.env.REACT_APP_GIT_COMMIT;

var websocketTest = true;
var websocketServerLocal = false;
var restServerTest = true;
var restServerLocal = false;
var photosTest = true;
var paypalPaymentTest = true;
var iframeTest = true;
if (!testEnv) {
  websocketTest = false;
  restServerTest = false;
  photosTest = false;
  paypalPaymentTest = false;
  iframeTest = false;
}
var _vc = {};

_vc.NATIVE_APP = nativeApp;
_vc.DESKTOP_APP = REACT_APP_DESKTOP_APP ?? false;
_vc.releaseHash = gitCommit;
console.debug(_vc.releaseHash);
if (_vc.NATIVE_APP) {
  try {
    const appVersion = DeviceInfo.getVersion();
    _vc.APP_VERSION_NAME = appVersion;
    console.debug('VERSION: ', appVersion);
    _vc.PLATFORM_IS_IOS = Platform.OS === 'ios';
    _vc.PLATFORM_IS_ANDROID = Platform.OS === 'android';
  } catch (e) {
    console.debug('Error in fetching version: ', e);
  }
}
_vc.REACT_APP_GOOGLE_IOS_ID = REACT_APP_GOOGLE_IOS_ID;
_vc.REACT_APP_GOOGLE_ANDROID_WEB_CLIENT_ID =
  REACT_APP_GOOGLE_ANDROID_WEB_CLIENT_ID;
_vc.REACT_APP_GOOGLE_ANDROID_CLIENT_ID = REACT_APP_GOOGLE_ANDROID_CLIENT_ID;
_vc.REACT_APP_ONE_SIGNAL_APP_ID = REACT_APP_ONE_SIGNAL_APP_ID;
_vc.REACT_APP_ONE_SIGNAL_IOS_APP_ID = REACT_APP_ONE_SIGNAL_IOS_APP_ID;
_vc.TEST_ENV = testEnv;
_vc.REST_SERVER_LOCAL = restServerLocal;
_vc.API_VERSION = 0.1;
_vc.SEPARATOR = ':';
_vc.IFRAME_TEST = iframeTest;
_vc.MINOR_APP_VERSION = nativeApp
  ? REACT_APP_MINOR_APPVERSION
  : process.env.REACT_APP_MINOR_APPVERSION;
_vc.MAJOR_APP_VERSION = nativeApp
  ? REACT_APP_MAJOR_APPVERSION
  : process.env.REACT_APP_MAJOR_APPVERSION;
_vc.APP_PLAYSTORE_LINK =
  'https://play.google.com/store/apps/details?id=com.consolto.app';
_vc.APP_APPSTORE_LINK =
  'https://apps.apple.com/us/app/consolto-video-chat/id1584996493';
_vc.APP_STORE_LINK_ID = '';
_vc.APP_PACKAGE_NAME = '';

_vc.VIDABOO_REST_HOST = _vc.VIDABOO_REST_HOST = restServerTest
  ? restServerLocal
    ? 'https://my-ip.yuvidio.com:2096'
    : nativeApp
      ? REACT_APP_REST_SERVER
      : process.env.REACT_APP_REST_SERVER
  : 'https://api.consolto.com';

_vc.VIDABOO_N1_REST_HOST = restServerTest
  ? restServerLocal
    ? 'https://my-ip.yuvidio.com:2053' // "http://localhost:2096"
    : nativeApp
      ? REACT_APP_N1_SERVER
      : process.env.REACT_APP_N1_SERVER
  : 'https://api.consolto.com';
_vc.VIDABOO_P1_REST_HOST = restServerTest
  ? restServerLocal
    ? 'https://my-ip.yuvidio.com:2083'
    : nativeApp
      ? REACT_APP_P1_SERVER
      : process.env.REACT_APP_P1_SERVER
  : 'https://api.consolto.com';

_vc.WEBSOCKET_HOST = websocketTest
  ? websocketServerLocal
    ? 'https://my-ip.yuvidio.com:443' // "wss://localhost"
    : nativeApp
      ? REACT_APP_WS_SERVER
      : process.env.REACT_APP_WS_SERVER
  : 'wss://ws.consolto.com';

// _vc.WEBSOCKET_HOST = 'https://35.93.81.57';

// _vc.VIDABOO_REST_HOST = 'https://35.93.81.57'; //

// _vc.VIDABOO_N1_REST_HOST = 'https://35.93.81.57';

_vc.MEDIA_MESSAGES_STORAGE = testEnv
  ? 'https://staging-media-messages.consolto.com'
  : 'https://media-messages.consolto.com';

_vc.STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
_vc.STRIPE_C2C_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_C2C_PUBLISHABLE_KEY;
_vc.STRIPE_C2C_CLIENT_ID = process.env.REACT_APP_STRIPE_C2C_CLIENT_ID;
_vc.PUSH_LAP_GROWTH_PROGRAM_ID =
  process.env.REACT_APP_PUSH_LAP_GROWTH_PROGRAM_ID;
_vc.HomePage = 'https://www.consolto.com';
_vc.APP_PAGE = _vc.NATIVE_APP
  ? REACT_APP_EXPERT_PAGE
  : process.env.REACT_APP_EXPERT_PAGE;
_vc.CLIENT_PAGE = _vc.NATIVE_APP
  ? REACT_APP_CLIENT_PAGE
  : process.env.REACT_APP_CLIENT_PAGE; // never put a '/' at the end. It will ruin payment
_vc.CLIENT_CLICKNTALK_DOMAIN = _vc.CLIENT_PAGE; // never put a '/' at the end. It will ruin payment

_vc.FILE_SERVER1 = 'https://fs1.consolto.com';
_vc.INSTRUCTIONS_LINKS = {
  HTML5:
    'https://www.consolto.com/knowledge-posts/general-website-installation-instructions',
  WORDPRESS:
    'https://www.consolto.com/knowledge-posts/wordpress-installation-instructions',
  SCREEN_SHARE_TROUBLESHOOT:
    'https://www.consolto.com/knowledge-posts/screen-share-troubleshooting',
  SCHEDULE: 'https://www.consolto.com/knowledge-posts/scheduling',
  AFFILIATE_PORTAL: 'https://www.consolto.com/documentation',
  SUPPORT_PORTAL: 'https://www.consolto.com/documentation',
  CLICKNTALK_INSTRUCTIONS:
    'https://www.consolto.com/knowledge-posts/embed-your-clickntalk-page-as-an-iframe',
  CNAME_INSTRUCTIONS:
    'https://www.consolto.com/knowledge-posts/use-cname-for-your-clickntalk-pages',
  CUSTOM_BUTTON_INSTRUCTIONS:
    'https://www.consolto.com/knowledge-posts/custom-buttons',

  TROUBLESHOOTING:
    'https://www.consolto.com/knowledge-posts/video-call-troubleshooting',
  PARTNER_JOIN_LINK: testEnv
    ? 'https://local-consolto-test.pushlapgrowth.com'
    : 'https://partners.consolto.com',
  TERMS_OF_USE: 'https://www.consolto.com/legal/terms-of-use',
  PRIVACY_POLICY: 'https://www.consolto.com/legal/privacy',
  ROADMAP: 'https://feedback.consolto.com/roadmap',
  IDEAS: 'https://feedback.consolto.com/b/6m4ygxm4/feature-requests',
  FEEDBACK: 'https://www.consolto.com/feedback',
  DOWNLOAD: 'https://www.consolto.com/features/desktop-and-mobile-apps',
  GOOGLE_ANALYTICS:
    'https://www.consolto.com/knowledge-posts/google-analytics-events',
  WEBSITE_API: 'https://www.consolto.com/knowledge-posts/web-frontend-api',
  PAYPAL_INSTRUCTIONS:
    'https://www.consolto.com/knowledge-posts/get-paid-for-your-video-chat-sessions',
  SET_UP_CUSTOMER_PAGES:
    'https://www.consolto.com/knowledge-posts/setup-your-agents-widget-and-clickntalk-page',
  THREED_INSTRUCTIONS: 'https://www.consolto.com/knowledge-posts/3d-sense',
  PAGE_MATCHES: 'https://www.consolto.com/knowledge-posts/page-matches',
  VIDEO_CALL_PERMISSIONS:
    'https://www.consolto.com/knowledge-posts/how-to-grant-camera-and-microphone-permissions-for-website-video-calls-with-consolto',
  ACTIVE_ENGAGER: 'https://www.consolto.com/knowledge-posts/active-engager',
  // SUPPORT_EMAIL: 'info@consolto.com', // DEPRECATED: Use whiteLabelContext.agencyContactEmail instead
  PRIVACY_FEATURE: 'https://www.consolto.com/knowledge-posts/privacy-features',
  TEAM_CONVERSATION_FEATURE:
    'https://www.consolto.com/knowledge-posts/team-conversation-features',
  WEBHOOKS: 'https://www.consolto.com/knowledge-posts/webhooks',
};
_vc.REST_PATHS = {
  //            GET_MENTOR_DATA : this.VIDABOO_REST_HOST + '/api/mentorFrontPage/ilan/harel/',
  ADMIN: _vc.VIDABOO_REST_HOST + '/api/users/user/',
  MENTOR: _vc.VIDABOO_REST_HOST + '/api/v1/mentors/',
  ACCOUNT: _vc.VIDABOO_REST_HOST + '/api/v1/accounts/',
  JOB_APPLICATION: _vc.VIDABOO_REST_HOST + '/api/v1/jobApplications/',
  SESSION_TEMPLATE: _vc.VIDABOO_REST_HOST + '/api/v1/sessionTemplates/',
  TOKBOX: _vc.VIDABOO_REST_HOST + '/api/v1/tokbox/',
  USER: _vc.VIDABOO_REST_HOST + '/api/v1/users/',
  RESELLER_AGENCY: _vc.VIDABOO_REST_HOST + '/api/v1/resellerAgency/',
  AGENCY_CUSTOMER: _vc.VIDABOO_REST_HOST + '/api/v1/agencyCustomer/',
  AGENCY_MEMBER: _vc.VIDABOO_REST_HOST + '/api/v1/agencyMember/',
  WIDGET: _vc.VIDABOO_REST_HOST + '/api/v1/widgets/',
  AUTH: _vc.VIDABOO_REST_HOST + '/api/v1/users/auth/',
  PAYMENT: _vc.VIDABOO_REST_HOST + '/api/v1/payments/',
  GET_SESSION_ID: _vc.VIDABOO_REST_HOST + '/api/mentor/getSession',
  GET_TOKEN: _vc.VIDABOO_REST_HOST + '/api/getToken',
  FileUploader: _vc.VIDABOO_REST_HOST + '/api/filehandler/',
  PHOTOS: _vc.VIDABOO_REST_HOST + '/api/v1/photos/',
  SESSION_INSTANCE: _vc.VIDABOO_REST_HOST + '/api/v1/sessionInstance/',
  // MAIL_MESSAGE: _vc.VIDABOO_REST_HOST + '/api/v1/messages/',
  SMS_MESSAGES: _vc.VIDABOO_REST_HOST + '/api/v1/smsMessages/',
  PUSH_NOTIFICATIONS: _vc.VIDABOO_REST_HOST + '/api/v1/pushNotifications/',
  CHAT_MESSAGE: _vc.VIDABOO_REST_HOST + '/api/v1/chatMessages/',
  CHAT_ROOM: _vc.VIDABOO_REST_HOST + '/api/v1/chatRooms/',
  BOOKING_FLOW_INSTNACE:
    _vc.VIDABOO_N1_REST_HOST + '/n1/api/v1/bookingFlowInstances/',
  THREED: _vc.VIDABOO_REST_HOST + '/api/v1/threed/',
  THREED_FILEID: _vc.VIDABOO_REST_HOST + '/api/v1/threedFileId/',
  ObjectType: _vc.VIDABOO_REST_HOST + '/api/v1/',
  THUMBNAIL: _vc.VIDABOO_REST_HOST + '/api/v1/thumbnail/',
  ANALYTICS_EVENTS: _vc.VIDABOO_REST_HOST + '/api/v1/analyticsEvents/',
  TRIP_GROUPS: _vc.VIDABOO_REST_HOST + '/api/v1/tripGroups/',
  TRIPS: _vc.VIDABOO_REST_HOST + '/api/v1/trips/',
  TRIPS_POI_OBJECTS: _vc.VIDABOO_REST_HOST + '/api/v1/tripPoiObjects/',
  BILLING_PLAN_EVENTS: _vc.VIDABOO_REST_HOST + '/api/v1/billingPlanEvent/',
  BILLING_PLANS: _vc.VIDABOO_REST_HOST + '/api/v1/billingPlan/',
  AUDIO_MESSAGES: _vc.VIDABOO_REST_HOST + '/api/v1/audioMessages/',
  AFFILIATE_INFO: _vc.VIDABOO_REST_HOST + '/api/v1/affiliateInfo/',
  REDEEM_GIFT: _vc.VIDABOO_REST_HOST + '/api/v1/gift/redeemGift',
  AFFILIATE_CONNECTIONS:
    _vc.VIDABOO_REST_HOST + '/api/v1/affiliateConnections/',
  FILE_MESSAGES: _vc.VIDABOO_REST_HOST + '/api/v1/fileMessages/',
  IMAGE_MESSAGES: _vc.VIDABOO_REST_HOST + '/api/v1/imageMessages/',
  APP_VERSION: _vc.VIDABOO_N1_REST_HOST + '/n1/api/v1/version/',
  ZAPIER: _vc.VIDABOO_N1_REST_HOST + '/n1/api/v1/integration/zapier/',
  WEBHOOK: _vc.VIDABOO_N1_REST_HOST + '/n1/api/v1/integration/webhook/',
  WHITE_LABEL: _vc.VIDABOO_REST_HOST + '/api/v1/controlledFeatures/',
  IMPERSONATION: _vc.VIDABOO_REST_HOST + '/api/v1/impersonation/',
  CONTROLLED: _vc.VIDABOO_REST_HOST + '/api/v1/controlledFeatures/',
  // TODO Replace it before merge
  MARKETING: _vc.VIDABOO_N1_REST_HOST + '/n1/api/v1/marketingParameters/',
  CALL_RECORDING: _vc.VIDABOO_REST_HOST + '/api/v1/callRecording/',
  PUBLIC_MEDIA_LINK: _vc.VIDABOO_REST_HOST + '/api/v1/publicMediaLink/',
  CALENDAR: _vc.VIDABOO_N1_REST_HOST + '/n1/api/v1/calendar/',
  GOOGLE_EMAIL: _vc.VIDABOO_N1_REST_HOST + '/n1/api/v1/gmail/',
  MESSAGE_BROKER: _vc.VIDABOO_N1_REST_HOST + '/n1/api/v1/messageBroker/',
  DYNAMIC_FORM: _vc.VIDABOO_N1_REST_HOST + '/n1/api/v1/dynamicFormTemplate',
  DYNAMIC_INSTANCE: _vc.VIDABOO_N1_REST_HOST + '/n1/api/v1/dynamicFormInstance',
  SUBSCRIPTION_TRANSACTIONS:
    _vc.VIDABOO_REST_HOST + '/api/v1/consoltoSubscriptionTransactions/',
  NEXT_PAYMENT:
    _vc.VIDABOO_REST_HOST + '/api/v1/payments/stripe/subscription/nextInvoice/',
  NOTIFY_CUSTOMER: _vc.VIDABOO_N1_REST_HOST + '/n1/api/v1/notify-customer',
  SMTP_INTEGRATION: _vc.VIDABOO_N1_REST_HOST + '/n1/api/v1/smtp/config/',
  MEETING_ROOM: _vc.VIDABOO_N1_REST_HOST + '/n1/api/v1/meetingRooms/',
  STRIPE_C2C: _vc.VIDABOO_N1_REST_HOST + '/n1/api/v1/c2c-payments/stripe/',
  C2C_MONEY_TRANSACTION_EVENT:
    _vc.VIDABOO_N1_REST_HOST + '/n1/api/v1/c2c-transactions/',
  AGENCY_CUSTOMER_BILLING:
    _vc.VIDABOO_REST_HOST + '/api/v1/agencyCustomerBilling/',
  CC_LINKAGE: _vc.VIDABOO_REST_HOST + '/api/v1/ccLinkage/',
  CNAME_INSTANCE: _vc.VIDABOO_N1_REST_HOST + '/n1/api/v1/cname-instance/',
  KB_RESOURCES: _vc.VIDABOO_P1_REST_HOST + '/p1/api/v1/kbResources/',
  BRAIN: _vc.VIDABOO_P1_REST_HOST + '/p1/api/v1/brain/',
  TRAINING: _vc.VIDABOO_P1_REST_HOST + '/p1/api/v1/kbTraining/',
  AI_COMPLETION: _vc.VIDABOO_P1_REST_HOST + '/p1/api/v1/completion/',
  AI_CREDITS_BALANCE: _vc.VIDABOO_REST_HOST + '/api/v1/creditBalance/',
  CHAT_HANDOFF_FLOW: _vc.VIDABOO_REST_HOST + '/api/v1/chatHandoffFlow/',
  AGENT_HANDOFF_FLOW: _vc.VIDABOO_P1_REST_HOST + '/p1/api/v1/handoff/',
  EMAIL_CUSTOMIZATION:
    _vc.VIDABOO_N1_REST_HOST + '/n1/api/v1/emailCustomization/',
};
_vc.MARKETING_PARAMETERS_ACTIVITY_TYPES = {
  FIRST_STEP_GUIDES: 'FIRST_STEP_GUIDES',
};
_vc.FLOIKS_FIRST_STEP_GUIDES = {
  INSTALLATION: 'INSTALLATION',
  CLICK_AND_TALK: 'CLICK_AND_TALK',
  SCHEDULING: 'SCHEDULING',
  VIDEO_CHAT: 'VIDEO_CHAT',
  TEXT_CHAT: 'TEXT_CHAT',
};
_vc.CALL_FAIL_TYPES = {
  SCHEDULE_MEETING: 'SCHEDULE_MEETING',
  TEXT_CHAT: 'TEXT_CHAT',
  WEBCALL: 'WEBCALL',
  FB_MESSENGER: 'FB_MESSENGER',
  CUSTOM_LINK: 'CUSTOM_LINK',
  WHATSAPP: 'WHATSAPP',
  INFO_COLLECTOR: 'INFO_COLLECTOR',
};
_vc.FORM_SUBMIT_TYPES = {
  SCHEDULE_MEETING: 'SCHEDULE_MEETING',
  TEXT_CHAT: 'TEXT_CHAT',
  WEBCALL: 'WEBCALL',
  FB_MESSENGER: 'FB_MESSENGER',
  CUSTOM_LINK: 'CUSTOM_LINK',
  WHATSAPP: 'WHATSAPP',
};
_vc.MEDIA_LIST_TYPES = [
  {value: 0, title: 'All Media'},
  {value: 1, title: 'Voice-messages'},
  {value: 2, title: 'Video-recordings'},
  {value: 3, title: 'Files'},
  {value: 4, title: 'Images'},
];
_vc.CALL_FAIL_TYPES_VALUE = {
  SCHEDULE_MEETING: 'Schedule',
  INFO_COLLECTOR: 'Contact Form',
  TEXT_CHAT: 'Live Chat',
  WEBCALL: 'Retry Call',
  FB_MESSENGER: 'Facebook Messenger',
  CUSTOM_LINK: 'Custom Link',
  WHATSAPP: 'Whatsapp',
  CALL_FAIL_MESSAGE: 'callFailMessage',
  PRE_IDENTIFICATION_TEXT: 'preIdentificationText',
};
_vc.FORM_SUBMIT_TYPES_VALUE = {
  SCHEDULE_MEETING: 'Schedule',
  TEXT_CHAT: 'Live Chat',
  WEBCALL: 'Video Call',
  FB_MESSENGER: 'Facebook Messenger',
  WHATSAPP: 'Whatsapp',
  CUSTOM_LINK: 'Custom Link',
  FORM_SUBMIT_MESSAGE: 'formSubmitMessage',
};

_vc.INDEX_DB = {
  NAME: 'consoltoDb',
  STORE: 'threeDFiles',
};

_vc.WS_CONNECTION_STATES = {
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected',
};
_vc.WS_AUTO_REFRESH_DELAY_MS = 60 * 1000;
_vc.TOK_BOX = {
  EXTENSION_ID: 'nhfjbienalifdeomfpbnofcodgffaghe',
};
_vc.MAX_VIDEO_STREAMS_PERMITTED = 24;

_vc.SESSION_INSTANCE_STATES = {
  CREATED: 'CREATED',
  REJECTED: 'REJECTED',
  NON_RESPONDED: 'NON_RESPONDED',
  ONGOING: 'ONGOING',
  ENDED: 'ENDED',
  DELETED: 'DELETED',
};

_vc.SESSION_INSTANCE_HEARTBEAT = {
  Client: 30000,
  Mentor: 30000,
};
_vc.SESSION_INSTANCE_MEETING_TYPES = {
  ON_DEMAND: 'ON_DEMAND',
  MEETING_ROOM: 'MEETING_ROOM',
};
_vc.CALL_RECORDING_STATES = {
  RECORDING: 'RECORDING',
  SAVING: 'SAVING',
  READY: 'READY',
  CANCELLED: 'CANCELLED',
  DELETED: 'DELETED',
};
_vc.CALL_TRANSCRIPTION_STATUS = {
  READY: 'READY',
  INIT: 'INIT',
  PENDING_AUDIO: 'PENDING_AUDIO',
  FAILED_ARCHIVE: 'FAILED_ARCHIVE',
  PENDING_TRANSCRIPTION: 'PENDING_TRANSCRIPTION',
  FAILED_TRANSCRIPTION: 'FAILED_TRANSCRIPTION',
  STREAM_TRASCRIPTIONS_AVAILABLE: 'STREAM_TRASCRIPTIONS_AVAILABLE',
  FAILED_COMPOSE: 'FAILED_COMPOSE',
  DELETED: 'DELETED',
};
_vc.FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID;
_vc.GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
_vc.OUTLOOK_CLIENT_ID = process.env.REACT_APP_OUTLOOK_CLIENT_ID;
_vc.ONE_SIGNAL_APP_ID = process.env.REACT_APP_ONE_SIGNAL_APP_ID;
_vc.CLOUD_PHOTOS = {
  CLOUD_NAME: 'expertips',
  DEFAULT_UPLOAD_PRESET: photosTest
    ? 'expertipsTestUploadPreset'
    : 'expertipsDeploymentUploadPreset',
  CROPPING: 'server',
  MULTIPLE: false,
  MAX_FILE_SIZE: 10000000,
  THUMBNAILS: '#uploaded_image',
  THEME: 'minimal',
  INLINE_CONTAINER: '#uploaderContainer',
  SHOW_POWERED_BY: false,
  RESOURCE_TYPE: 'image',
  CLIENT_ALLOWED_FORMATS: ['png', 'gif', 'jpeg', 'jpg'],

  DEFAULT_MENTOR_BACKGROUND_PHOTO:
    'https://res.cloudinary.com/expertips/image/upload/c_fit,h_300,w_300/v1491934767/expertipsPhotos/default_mentor_background_photo.jpg',
  DEFAULT_MENTOR_BACKGROUND_PHOTO_BANNER:
    'https://res.cloudinary.com/expertips/image/upload/v1491934767/expertipsPhotos/default_mentor_background_photo.jpg',

  DEFAULT_MENTOR_PROFILE_PHOTO: 'app/html-template/images/default-profile.png',
  DEFAULT_SESSION_BACKGROUND_PHOTO:
    'https://res.cloudinary.com/expertips/image/upload/c_thumb,h_80,w_80,q_50/v1491934767/expertipsPhotos/default_session_template_background.jpg',
};

_vc.MENTOR_OWNER_TYPE = {
  PERSONAL: 'PERSONAL',
  WIDGET: 'WIDGET',
};
_vc.PHOTO_TYPES = {
  PROFILE: 'PROFILE',
  SESSION: 'SESSION',
  BACKGROUND: 'BACKGROUND',
  VIDEO_BACKGROUND: 'VIDEO_BACKGROUND',
  FAVICON: 'FAVICON',
  EMAIL_LOGO: 'EMAIL_LOGO',
  EMAIL_CUSTOMIZATION: 'EMAIL_CUSTOMIZATION',
};
_vc.PHOTO_OBJECT_TYPES = {
  MENTOR: 'MENTOR',
  USER: 'USER',
  SESSION_TEMPLATE: 'SESSIONTEMPLATE',
  ACCOUNT: 'ACCOUNT',
  WIDGET: 'WIDGET',
  RESELLERAGENCY: 'RESELLERAGENCY',
};
_vc.PAYPAL_RETURN_URL = paypalPaymentTest
  ? 'http://localhost:3000/public'
  : _vc.CLIENT_PAGE;
//_vc.PAYPAL_RETURN_URL = staticAppTest ? 'https://preview.c9users.io/iharel/yuvidio-front-end/static-app' : _vc.WEBSOCKET_HOST;
_vc.PAYPAL_WINDOW_URL = paypalPaymentTest // for c2c payments
  ? 'https://www.sandbox.paypal.com/cgi-bin/webscr?cmd=_ap-payment&paykey='
  : 'https://www.paypal.com/cgi-bin/webscr?cmd=_ap-payment&paykey=';

_vc.PAYPAL_SUBSCRIPTION_URL = paypalPaymentTest
  ? 'https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=P5TMMEAFH8W2N'
  : 'https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=L8YEZCFUB9PUL';

_vc.PAYPAL_CLIENT_ID_OLD = paypalPaymentTest
  ? 'AXFpdBmzytVenTUqG251N8YXqMyIsZ-T2rgUkV0-D1Cp_rDD4-iNIaJkHvzwMZN7uRjl0lyJ-XoS2LmY'
  : 'AfpNevPhgBQ1gXrbM8CiTCtofk4wWjyKITnkCxwe-w6ncwTpGQEizKLUVgrn5I5lUoUUU7sAZ-jHZtjV';
_vc.PAYPAL_CLIENT_ID = paypalPaymentTest
  ? 'ARKVOWQTKWfVyFx-V4PsM0OSryU1nPjQDHzTx_vm9RXYKfHuideEQPr51sTCAtc6LKwiHLrm7DMVW89b'
  : 'AVXHv2HMOWOS992v9UYVIEvcBHnHpDI0BAQt6D5jA7jZ29UmeYGYY0NhQzjy6vF0qrP9Hc9jPLNVuF_d';

_vc.MOBILE_TABS = {
  HOME: 'home',
  INFORMATION: 'info',
  NOTIFICATIONS: 'notifications',
};

/////////////    WS MESSAGES     /////////
_vc.WEBSOCKET_PRIVATE_ROOM_ALL = 'ALL';

_vc.WEBSOCKET_MESSAGE_TYPES = {
  AVAILABILITY_STATUS: 'availabilityStatus',
  CHAT: 'chat',
  CHAT_NO_SAVE: 'chatNoSave',
  CHAT_NO_PASS: 'chatNoPass',

  MAP: 'map',
  CALL: 'call',
  ENGAGER: 'engager',
  DIRECT_PAYMENT: 'directPayment',
  ACK: 'ack',
  INVITE_TO_PR: 'inviteToPR',
  THREED: 'threeD',
  VIDEO_RECORDING: 'videoRecording',
  SCHEDULING: 'scheduling',
  MEETING_ROOM: 'meetingRoom',
  PRIVATE_CHAT_ROOM: 'privateChatRoom',
  KB_UPDATE: 'kbUpdate',
  AI_COMPLETION_UPDATE: 'aiCompletionUpdate',
  TRAINING_COMPLETION_UPDATE: 'trainingCompletionUpdate',
  HANDOFF_FLOW: 'handoffFlow',
  WIDGET_TEAM: 'widgetTeam',
};
_vc.WEBSOCKET_MESSAGE_SUB_TYPES = {
  // type: aiCompletionUpdate
  COMPLETION_STARTED: 'completionStarted',
  COMPLETION_SUCCESS: 'completionSuccess',
  COMPLETION_STOPPED: 'completionStopped',
  COMPLETION_FAILURE: 'completionFailure',
  HANDOFF_FLOW_START: 'handoffFlowStart',
  // type: handoffFlow
  HANDOFF_FLOW_UPDATE: 'handoffFlowUpdate',
  HOT_HANDOFF_FAILED: 'hotHandoffFailed',
  HOT_HANDOFF_SUCCEEDED: 'hotHandoffSucceeded',
  HOT_HANDOFF_PENDING: 'hotHandoffPending',
  COLD_HANDOFF_DONE: 'coldHandoffDone',
};
_vc.AVAILABILITY_STATES = {
  AVAILABLE: 'available',
  BUSY: 'busy',
  OFFLINE: 'offline',
  STANDBY: 'standby',
  // ONLINE: "online"
};
_vc.WIDGET_TEAM_SUBTYPES = {
  TEAM_PARTICIPANTS_UPDATE: 'teamParticipantsUpdate',
};
_vc.CALL_SUBTYPES = {
  CALL_REQUEST: 'CallRequest',
  REQUEST_TO_RESEND_CALL_REQUEST: 'resendCallRequest',
  REQUEST_JOIN_CALL: 'requestJoinCall', //
  RESPONSE_TO_JOIN_CALL_REQUEST: 'responseToJoinCallRequest',
  PAYMENT_STATUS: 'PaymentStatus',
  PEER_DISCONNECT: 'PeerDisconnect',
  CAMERA_STATE: 'NoCamera',
  RESPONSE_TO_CALL_REQUEST: 'ResponseToCallRequest',
  HANGUP: 'HangUp',
  CALL_RECORDING_STARTED: 'CALL_RECORDING_STARTED',
  CALL_RECORDING_ENDED: 'CALL_RECORDING_ENDED',
};
_vc.WEBSOCKET_ROOM_TYPES = {
  LISTENING: 'LISTENING',
  PRIVATE: 'PRIVATE',
};

_vc.SCHEDULING = {
  NEW_BFI: 'newBfi',
  UPDATE_BFI: 'updateBfi',
};
_vc.CALL_RESPONSE_STATES = {
  ACCEPT: 'accept',
  REJECT: 'reject',
  ACCEPTPAYMENT: 'acceptPayment',
};
_vc.PUSH_NOTIFICATIONS_SUB_TYPES = {
  TEXT_MESSAGE: 'text',
  VIDEOCHAT_MESSAGE: 'videocall',
  SCHEDULE_MEETING: 'schedule',
  OTHER: 'other',
};
_vc.CHAT_SUBTYPES = {
  // don't change the following. Impact server.
  TEXT_MESSAGE: 'text',
  AUDIO_MESSAGE: 'audio',
  FILE_MESSAGE: 'file',
  IMAGE_MESSAGE: 'image',
  CUSTOM_LINK_MESSAGE: 'custom_link',
  WHATSAPP_MESSAGE: 'whatsapp',
  PHONE_MESSAGE: 'phonecall',
  MESSENGER_MESSAGE: 'fb-messenger',
  INFO_MESSAGE: 'infolead',
  VIDEOCHAT_MESSAGE: 'videochat',
  SCHEDULE_MEETING: 'schedule',
  NOTES_MESSAGE: 'notes',
  VIDEO_RECORDING: 'videoRecording',
  OB_EMAIL: 'ob-email', // outbound email
  MONEY_TRANSACTION: 'moneyTransaction',
  TASK_OWNER_UPDATE: 'taskOwnerUpdate',
  TRANSITION_TO_MENTOR_CHAT_ROOM: 'transitionToMentorChatRoom',
  OONI_AI: 'ooni-ai',
  HANDOFF_FLOW_START: 'handoffFlowStart',
  HANDOFF_PENDING: 'handoffPending',
  TASK_OWNER_EVENT: 'taskOwnerEvent',
  SESSION_INSTANCE: 'sessionInstance',
};

_vc.INFO_MESSAGE_SUBTYPES = {
  FORM_CONFIRMATION: 'formConfirmation',
};

_vc.CHAT_NO_SAVE_SUBTYPES = {
  GET_USERS: 'GetUsers',
  USER_IS_TYPING: 'UserIsTyping',
  USER_STOPPED_TYPING: 'UserStoppedTyping',
  MESSAGE_WAS_SEEN_BY_USER: 'MessageWasSeenByUser',
  VIDEO_RECORDING_UPDATE: 'videoRecordingUpdate',
  DELETE_CHAT_MESSAGE: 'deleteChatMessage',
  DELETE_CHAT_ROOM: 'deleteChatRoom',
  SESSION_INSTANCE_CREATED: 'sessionInstanceCreated',
  SESSION_INSTANCE_DELETED: 'sessionInstanceDeleted',
  SESSION_INSTANCE_UPDATE: 'sessionInstanceUpdate',
  CALL_RECORDING_CREATED: 'callRecordingCreated',
  CALL_RECORDING_DELETED: 'callRecordingDeleted',
  CALL_RECORDING_UPDATE: 'callRecordingUpdate',
  CALL_TRANSCRIPTION_CREATED: 'callTranscriptionCreated',
  CALL_TRANSCRIPTION_DELETED: 'callTranscriptionDeleted',
  CALL_TRANSCRIPTION_UPDATE: 'callTranscriptionUpdate',
};

_vc.PRIVATE_ROOM_DESTINATION_GROUPS = {
  ACTIVE_LISTENERS_ONLY: 'ACTIVE_LISTENERS_ONLY', // will not involve J1
  ALL_PERMISSIONED_LISTENERS: 'ALL_PERMISSIONED_LISTENERS',
};

_vc.THREEDFILE_UPDATES = {
  TITLE: 'title',
  INITIALCAMERATSETTINGS: 'initialCameraSettings',
  INITIALLIGHTSETTINGS: 'initialLightSettings',
};

_vc.DIRECT_PAYMENT_SUBTYPES = {
  PAYMENT_REQUEST: 'paymentRequest',
  PAYMENT_REQUEST_RECEIVED: 'paymentRequestReceived',
  PAYMENT_REQUEST_ACCEPTED: 'paymentRequestAccepted',
  PAYMENT_REQUEST_REJECTED: 'paymentRequestRejected',
  PAYMENT_POST_PAYMENT_RESOLUTION: 'PAYMENT_POST_PAYMENT_RESOLUTION',
};
_vc.MAP_SUBTYPES = {
  PIN_LOCATION: 'PinLocation',
  DELETE_PIN: 'DeletePin',
  TEXT_BOX: 'TextBox',
  DIRECTIONS: 'Directions',
  ADD_SUB_TRIP: 'AddSubTrip',
  DELETE_SUB_TRIP: 'DeleteSubTrip',
  REFRESH_POI_OBJECTS: 'RefreshPoiObjects',
  SUB_TRIPS: 'SubTrips',
  OPEN_MAP_REQUEST: 'OpenMapRequest',
};
_vc.DAG_SUBTYPES = {
  STATUS_REQUEST: 'status_request',
  ENDPOINT_INDICATION: 'endpoint_indication',
  WIDGET_OPEN_STATE: 'widget_open_state',
};

_vc.ENGAGER_SUBTYPES = {
  INTERACTION_REQUEST: 'interaction_request',
  ENDPOINT_RCVD_INTERACTION_REQUEST: 'endpoint_rcvd_interaction_request',
  RESPONSE_TO_INTERACTION_REQUEST: 'RESPONSE_TO_INTERACTION_REQUEST',
};

_vc.THREED_SUBTYPES = {
  RENDER_CHANGE: 'RenderChange',
  OPEN_THREED_REQUEST: 'openThreedRequest',
  CLOSE_THREED_REQUEST: 'closeThreedRequest',
};

_vc.MEETING_ROOM_SUBTYPES = {
  CUSTOMER_STATUS: 'customerStatus',
  MENTOR_STATUS: 'mentorStatus',
  STATUS_REQUEST: 'statusRequest',
  MEETING_INFO_REQUEST: 'meetingInfoRequest',
  MEETING_INFO_RESPONSE: 'meetingInfoResponse',
};

_vc.MEETING_ROOM_USER_STATUS = {
  JOINED_ROOM: 'joinedRoom',
  NOT_JOINED_ROOM: 'notJoinedRoom',
  ANOTHER_CALL: 'anotherCall',
};

_vc.CHAT_AUTOMATIC_MSG = '👋 Hey there!';
_vc.AUTOMATED_MSG_TYPES = {
  AUTOMATIC_MESSAGE: 'automaticMessage',
  NON_RESPONDANT_MESSAGE: 'nonRespondantMessage',
};
_vc.CHAT_ROOM_OWNER_TYPE = {
  TEAM_MENTOR: 'TEAM_MENTOR',
  MENTOR: 'MENTOR',
};
_vc.CHAT_PARTICIPANT_TYPES = {
  ACCOUNT: 'ACCOUNT',
  WIDGET: 'WIDGET',
  GUEST: 'GUEST',
  MENTOR: 'MENTOR',
  OONI_AI: 'OONI_AI',
  EXTERNAL_API: 'EXTERNAL_API',
  AUTOMATED_MESSAGE: 'AUTOMATED_MESSAGE',
};
_vc.CHAT_PARTICIPANT_PERMISSION = {
  READ: 'READ',
  WRITE: 'WRITE',
  NONE: 'NONE',
};
_vc.WIDGET_PRIVACY_MODES = {
  FULLY_PRIVATE: 'FULLY_PRIVATE',
  HALF_PRIVATE: 'HALF_PRIVATE',
  FULLY_SHARED: 'FULLY_SHARED',
};
_vc.WIDGET_ADMIN_ROLES = {
  NONE: 'NONE',
  READ_PRIVATE: 'READ_PRIVATE',
  ADMIN: 'ADMIN',
};
_vc.USER_ROLES = {
  STANDARD: 'STANDARD',
  MENTOR: 'MENTOR',
  GUEST: 'GUEST',
  ADMIN: 'ADMIN',
  EMAIL: 'EMAIL',
};
_vc.WIDGET_TEAM_WRITE_MODES = {
  ALL_WRITE: 'ALL_WRITE',
  TASK_OWNER_WRITE: 'TASK_OWNER_WRITE',
};
_vc.CHAT_ROOM_TYPES = {
  ONE_ON_ONE: 'ONE_ON_ONE',
  ONE_TO_MANY: 'ONE_TO_MANY',
};
_vc.LOCAL_STORAGE_ROOM_INITIATOR = {
  ACTION_CLICK: 'ACTION_CLICK',
  WEBSOCKET: 'WEBSOCKET',
};

_vc.PRIVATE_CHAT_ROOM_SUBTYPES = {
  PRIVATE_CHAT_ROOM_INFO_REQUEST: 'privateChatRoomInfoRequest',
  PRIVATE_CHAT_ROOM_INFO_RESPONSE: 'privateChatRoomInfoResponse',
};

_vc.KB_UPDATE_SUBTYPES = {
  CRAWL_UPDATE: 'crawlUpdate',
  TRAINING_UPDATE: 'trainingUpdate',
  KBR_UPDATE: 'kbrUpdate',
};
_vc.AI_COMPLETION_UPDATE_SUBTYPES = {
  COMPLETION_RESPONSE: 'completionResponse',
  COMPLETION_ERROR: 'completionError',
  DEMO_COMPLETION: 'demoCompletion',
};
_vc.TRAINING_COMPLETION_UPDATE_SUBTYPES = {
  TRAINING_RESPONSE: 'trainingResponse',
};
_vc.ENDPOINT_INDICATION_STATES = {
  // for engager endpoind indication states
  HIDDEN: 'hidden',
  ARRIVED: 'arrived',
  VISIBLE: 'visible',
  ATTENTION: 'attention',
};

_vc.ENDPOINT_WIDGET_OPEN_STATES = {
  WIDGET_CLOSED: 'widgetClosed',
  WIDGET_OPEN: 'widgetOpen',
};
/////////////    WS MESSAGES END    /////////

_vc.HANDOFF_ACTIONS = {
  // HOT
  VIDEO_CALL: 'VIDEO_CALL',
  TEXT_CHAT: 'TEXT_CHAT',
  // COLD
  SCHEDULING: 'SCHEDULING',
  CONTACT_FORM: 'CONTACT_FORM',
  WHATSAPP: 'WHATSAPP',
  FB_MESSENGER: 'FB_MESSENGER',
  PHONE: 'PHONE',
};

_vc.ERROR_CODE_TYPE = {
  MENTOR_GENERIC_EXCEPTION_CODES: 'MENTOR_GENERIC_EXCEPTION_CODES',
  KB_RESOURCE: 'KB_RESOURCE',
  BRAIN: 'BRAIN',
  TRAINING: 'TRAINING',
  CHAT: 'CHAT',
  FILE: 'FILE',
  AGENT_HANDOFF: 'AGENT_HANDOFF',
  RESELLER: 'RESELLER',
};

_vc.ERROR_CODES = {
  [_vc.ERROR_CODE_TYPE.MENTOR_GENERIC_EXCEPTION_CODES]: {
    MENTOR_COUNT_LIMIT_REACHED: 'M-006',
  },
  [_vc.ERROR_CODE_TYPE.KB_RESOURCE]: {},
  [_vc.ERROR_CODE_TYPE.BRAIN]: {},
  [_vc.ERROR_CODE_TYPE.TRAINING]: {
    'TRN-005': 'Insufficient tokens to perform training',
    'TRN-006': 'There is no active training flow',
  },
  [_vc.ERROR_CODE_TYPE.CHAT]: {
    'CG-007':
      'One of the selected agent skins has not provided you access to their private data.',
  },
  [_vc.ERROR_CODE_TYPE.FILE]: {
    'KBR-021': 'Only file download is allowed',
    'KBR-032': 'File not found',
  },
  [_vc.ERROR_CODE_TYPE.AGENT_HANDOFF]: {
    'AH-003':
      'None of the agents are available to accept the request. Please try again later.',
  },
  [_vc.ERROR_CODE_TYPE.RESELLER]: {
    'RA-023': 'Cannot demote the last admin of the agency.',
  },
};

_vc.SEARCH_SETTING = {
  PAGE_SIZE: 100,
};

_vc.SESSION_TITLE_MIN_CHARS = 5;
_vc.SESSION_TITLE_MAX_CHARS = 60;
_vc.CHANNEL_NAME_MAX_CHARS = 15;
_vc.AUTOMATIC_MESSAGE_MIN_CHARS = 0;
_vc.AUTOMATIC_MESSAGE_MAX_CHARS = 300;
_vc.SESSION_DESCRIPTION_MIN_CHARS = 10;
_vc.SESSION_DESCRIPTION_MAX_CHARS = 500;
_vc.MENTOR_DESCRIPTION_MIN_CHARS = 10;
_vc.MENTOR_DESCRIPTION_MAX_CHARS = 1000;
_vc.MENTOR_TITLE_MIN_CHARS = 5;
_vc.MENTOR_TITLE_MAX_CHARS = 60;
_vc.MESSAGE_TO_MENTOR_MIN_CHARS = 5;
_vc.MESSAGE_TO_MENTOR_MAX_CHARS = 500;
_vc.WIDGET_CTA_MESSAGE_MAX_CHARS = 80;
_vc.WIDGET_CTA_BTN_MAX_CHARS = 25;
_vc.PRE_WIDGET_MAX_CHARS = 25;
_vc.MENTOR_PROFILE_NAME_MAX_CHARS = 20;
_vc.PASSWORD_MIN_CHARS = 8;
_vc.PASSWORD_MAX_CHARS = 50;
_vc.SMTP_PASSWORD_MAX_CHARS = 200;
_vc.PHONE_NUMER_MIN_CHARS = 10;
_vc.PHONE_NUMER_MAX_CHARS = 14;
_vc.WIDGET_NAME_MAX_CHARS = 50;
_vc.WIDGET_CHAT_WITH_US_MAX_CHARS = 40;
_vc.WIDGET_ACTION_SELECTOR_TEXT_MAX_CHARS = 40;
_vc.PROFILE_NAME_MAX_CHARS = 28;
_vc.TEXT_AREA_MAX_ROWS = 3;
_vc.MAX_FILE_SIZE_IN_MB = 10;
_vc.MAX_THREED_SIZE_IN_MB = 80;
_vc.GENERIC_REQUIRED_STR_CHARS = 200;

_vc.VALIDATION_PATTERNS = {
  EMAIL:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  ANY_EMAIL_IN_STRING:
    /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/,
  EMAIL_OR_BLANK:
    /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/,
  HTML_START_OR_END_ELEMENT: /<\/?[a-z][\s\S]*>/i,
  NAME: /^[áéíóúüñÁÉÍÓÚÜÑa-zA-Z0-9]{2,20}$/,
  NAME_WITH_SPACES: /^[áéíóúüñÁÉÍÓÚÜÑa-zA-Z ]{2,20}$/,
  SMTP_USERNAME: /^.{2,200}$/,
  FORM_TITLE: /^.{1,60}$/,
  FORM_PLACEHOLDER: /^.{0,60}$/,
  FORM_CONSENT_MSG: /^.{1,800}$/,
  FORM_TOOLTIP: /^.{0,200}$/,
  FORM_FIELD_NAME: /^[a-z0-9_]{1,256}$/,
  OTHER_LANG_NAME: /^.{2,20}$/,
  PROFILE_NAME: /^.{2,40}$/,
  NUMBER: /^\d+$/,
  PHONE_NUMBER: /(^$|^\d{10,14}$)/,
  WHATSAPP_PHONE_NUMBER: /(^$|^\d{10,14}$)/,
  WIDGET_NAME: /^.{1,50}$/,
  ACCOUNT_NAME: /^.{0,40}$/,
  COMMUNICATION_URL: /\/(active|inActive)Channels/g,
  QA_QUESTION: /^[\s\S]{1,200}$/,
  QA_ANSWER: /^[\s\S]{1,800}$/,
  GENERIC_REQUIRED_STR: /^.{1,200}$/,

  REQUIRED_STR: /^.{1,800}$/,
  COST: /^[0-9]{1,7}$/,
  PASS_STRONG: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
  PASS_MEDIUM: /^.{8,50}$/,
  PRE_WIDGET_TEXT: new RegExp(
    '^.{' + 0 + ',' + _vc.PRE_WIDGET_MAX_CHARS + '}$',
  ),
  AUTOMATIC_MESSAGE: new RegExp(
    '^.{' +
      _vc.AUTOMATIC_MESSAGE_MIN_CHARS +
      ',' +
      _vc.AUTOMATIC_MESSAGE_MAX_CHARS +
      '}$',
  ),
  SESSION_TITLE: new RegExp(
    '^.{' +
      _vc.SESSION_TITLE_MIN_CHARS +
      ',' +
      _vc.SESSION_TITLE_MAX_CHARS +
      '}$',
  ),
  SESSION_DESCRIPTION: new RegExp(
    '^.{' +
      _vc.SESSION_DESCRIPTION_MIN_CHARS +
      ',' +
      _vc.SESSION_DESCRIPTION_MAX_CHARS +
      '}$',
  ),
  MENTOR_TITLE: new RegExp(
    '^.{' +
      _vc.SESSION_TITLE_MIN_CHARS +
      ',' +
      _vc.SESSION_TITLE_MAX_CHARS +
      '}$',
  ),
  MENTOR_DESCRIPTION: new RegExp(
    '^[^]{' +
      _vc.MENTOR_DESCRIPTION_MIN_CHARS +
      ',' +
      _vc.MENTOR_DESCRIPTION_MAX_CHARS +
      '}$',
  ),
  PASSWORD: new RegExp(
    '^[^]{' + _vc.PASSWORD_MIN_CHARS + ',' + _vc.PASSWORD_MAX_CHARS + '}$',
  ),
  SMTP_PASSWORD: new RegExp(
    '^[^]{' + _vc.PASSWORD_MIN_CHARS + ',' + _vc.SMTP_PASSWORD_MAX_CHARS + '}$',
  ),
  WEBSITE:
    /^(https?:\/\/)?[a-zA-Z0-9@:%._+\-~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/,

  MARKDOWN_URL:
    /\[([^\]]+)\]\(((?:https?:\/\/)?[a-zA-Z0-9@:%._+\-~#=]{2,256}\.[a-z]{2,6}\b(?:[-a-zA-Z0-9@:%_+.~#?&//=]*))\)/gi,

  ANY_URL:
    /(https?:\/\/)?[a-zA-Z0-9@:%._+\-~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/gi,
  ANY_URL_OR_NULL:
    /(^$|(https?:\/\/)?[a-zA-Z0-9@:%._+\-~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*))/gi,
  ANY_URL2: new RegExp(
    '(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?',
    'g',
  ),
  DOMAIN_NAME: /^[a-zA-Z0-9]+([-.][a-zA-Z0-9]+)*$/,
  WEBSITE_LINK: /^https?:\/\/[a-zA-Z0-9\-.]+.[a-zA-Z]{2,}(\/[^\s]*)?$/, // todo 1720 : review with Ilan
  SITEMAP_LINK:
    /^(https?):\/\/[a-zA-Z0-9\-.]+.[a-zA-Z]{2,}(\/[^\s]*)?\/sitemap(_index)?\.xml$/i, // todo 1720 : review with Ilan

  MESSAGE_TO_MENTOR: new RegExp(
    '^.{' +
      _vc.MESSAGE_TO_MENTOR_MIN_CHARS +
      ',' +
      _vc.MESSAGE_TO_MENTOR_MAX_CHARS +
      '}$',
  ),
  WIDGET_CTA_MESSAGE: new RegExp(
    '^.{' + 0 + ',' + _vc.WIDGET_CTA_MESSAGE_MAX_CHARS + '}$',
  ),
  STRIPE_ACCOUNT_ID: /^acct_/,
};

_vc.PAYMENT_WINDOW_TIMER = {
  TIMER_WARNING: 500,
  TIMER_TIMEOUT: 1000,
};

_vc.PAYMENT_AMOUNT = {
  MIN_VALUE: 1,
  MAX_VALUE: 200,
};

_vc.CALL_TIMER = {
  NUMBER_OF_RETRIES: 0,
  TIMER_TIMEOUT: 50000,
  TIMER_WAITING_TIME: 300,
};

_vc.PEER_IS_TYPING_INDICATION_TIME = 7000;

_vc.BOOKING_FLOW = {
  DTO_ROLES: {
    EMAIL_ROLE: 'EMAIL',
    STANDARD_ROLE: 'STANDARD',
    ADMIN_ROLE: 'ADMIN',
  },
};

_vc.RESELLER_AGENCY_USER_ROLES = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER',
  NONE: 'NONE', // this role is not used in backend side. Role of NONE is used for sub account users
};

_vc.RESELLER_ACCOUNT_STATUS = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
};

_vc.WIDGET_POSTPONE_TIME = 7 * 24 * 60 * 60 * 1000; // 7 days

_vc.DEFAULT_SESSION_TIME = 30 * 60 * 1000; // 30 minutes
/////////////    ANALYTICS EVENTS    /////////

_vc.ANALYTICS_CATEGORIES = {
  PAGEVIEW: 'PAGEVIEW',
  ENGAGER: 'ENGAGER',
  WIDGET: 'WIDGET',
  WIDGET_FOR_PARENT_FRAME: 'CONSOLTO_WIDGET',
  FRONT_PAGE: 'FRONT_PAGE',
  CALL: 'CALL',
  CHAT: 'CHAT',
  BACKOFFICE: 'BACKOFFICE',
  PAYMENT_TO_CONSOLTO: 'PAYMENT_TO_CONSOLTO',
  MEETING_ROOM: 'MEETING_ROOM',
  ANONYMOUS_PAGE: 'ANONYMOUS_PAGE',
  MEDIA_PAGE: 'MEDIA_PAGE',
};
_vc.ANALYTICS_ACTIONS = {
  PAGEVIEW: {
    ENTER_PAGE: 'ENTER_PAGE',
    WIDGET_PAGE_VIEW: 'WIDGET_PAGE_VIEW',
    AGENT_LIST_VIEW: 'AGENT_LIST_VIEW',
    SINGLE_AGENT_VIEW: 'SINGLE_AGENT_VIEW',
  },
  ENGAGER: {
    CHAT_REQUEST: 'CHAT_REQUEST',
    CALL_REQUEST: 'CALL_REQUEST',
    ACCEPT_ENGAGER_REQUEST: 'ACCEPT_ENGAGER_REQUEST',
    REJECT_ENGAGER_REQUEST: 'REJECT_ENGAGER_REQUEST',
  },
  FRONT_PAGE: {
    SHOW_BOOKING_MODULE: 'SHOW_BOOKING_MODULE',
    SEND_BOOKING_REQUEST: 'SEND_BOOKING_REQUEST',

    SEND_FB_MESSAGE: 'SEND_FB_MESSAGE',
    SEND_WHATSAPP_MESSAGE: 'SEND_WHATSAPP_MESSAGE',
    SEND_CUSTOM_LINK_MESSAGE: 'SEND_CUSTOM_LINK_MESSAGE', // todo : discuss with Ilan
    CONSOLTO_LINK: 'CONSOLTO_LINK',
    OPEN_INFO_COLLECTOR: 'OPEN_INFO_COLLECTOR',
    MESSAGE_TO_MENTOR: 'MESSAGE_TO_MENTOR',
    OPEN_CHAT: 'OPEN_CHAT',
  },
  WIDGET: {
    SEND_BOOKING_REQUEST: 'SEND_BOOKING_REQUEST',
    OPEN_PRE_WIDGET: 'OPEN_PRE_WIDGET',
    OPEN_WIDGET: 'OPEN_WIDGET',
    CLOSE_WIDGET: 'CLOSE_WIDGET',
    CLOSE_ACCOUNT_WIDGET: 'CLOSE_ACCOUNT_WIDGET',
    SEND_FB_MESSAGE: 'SEND_FB_MESSAGE',
    SEND_WHATSAPP_MESSAGE: 'SEND_WHATSAPP_MESSAGE',
    SEND_CUSTOM_LINK_MESSAGE: 'SEND_CUSTOM_LINK_MESSAGE', // todo : discuss with Ilan
    CONSOLTO_LINK: 'CONSOLTO_LINK',
    CONSOLTO_MULTI_LINK: 'CONSOLTO_MULTI_LINK',
    MESSAGE_TO_MENTOR: 'MESSAGE_TO_MENTOR',
    PHONE_CALL: 'PHONE_CALL',
    OPEN_CHAT: 'OPEN_CHAT',
    CALL_STARTED_CLIENT: 'CALL_STARTED_CLIENT',
    CALL_ENDED_CLIENT: 'CALL_ENDED_CLIENT',
    CHAT_MESSAGE_RECEIVED: 'CHAT_MESSAGE_RECEIVED',
    CHAT_MESSAGE_SENT: 'CHAT_MESSAGE_SENT',
    AVAILABILITY_STATE_CHANGE: 'AVAILABILITY_STATE_CHANGE',
  },
  CALL: {
    START_CALL: 'START_CALL',
    ACCEPT_CALL: 'ACCEPT_CALL',
    REJECT_CALL: 'REJECT_CALL',
    ACCEPT_CALL_PAYMENT: 'ACCEPT_CALL_PAYMENT',
  },
  BACKOFFICE: {
    ENTER_PAGE: 'ENTER_PAGE',
  },
  CHAT: {
    CLIENT_START_CHAT: 'CLIENT_START_CHAT',
    MENTOR_START_CHAT: 'MENTOR_START_CHAT',
    CLIENT_SENT_AUDIO_MESSAGE: 'CLIENT_SENT_AUDIO_MESSAGE',
    MENTOR_SENT_AUDIO_MESSAGE: 'MENTOR_SENT_AUDIO_MESSAGE',
  },
  PAYMENT_TO_CONSOLTO: {
    STARTED_SUBSCRIBE: 'STARTED_SUBSCRIBE',
    COMPLETED_SUBSCRIBE: 'COMPLETED_SUBSCRIBE',
    CHANGED_SUBSCRIPTION: 'CHANGED_SUBSCRIPTION',
    CANCELLED_SUBSCRIPTION: 'CANCELLED_SUBSCRIPTION',
  },
  MEETING_ROOM: {
    ENTER_PAGE: 'ENTER_PAGE',
    START_JOIN_MEETING: 'START_JOIN_MEETING',
    MEETING_IN_PROGRESS: 'MEETING_IN_PROGRESS',
    CONSOLTO_LINK: 'CONSOLTO_LINK',
  },
  ANONYMOUS_PAGE: {
    ENTER_PAGE: 'ENTER_PAGE',
    CONSOLTO_LINK: 'CONSOLTO_LINK',
  },
  MEDIA_PAGE: {
    ENTER_PAGE: 'ENTER_PAGE',
    CONSOLTO_LINK: 'CONSOLTO_LINK',
  },
};
_vc.WIDGET_SIZE = {
  HIDDEN: 'hidden',
  WIDGET_CLOSED_TINY: 'tiny',
  WIDGET_CLOSED: 'small',
  WIDGET_OPEN: 'medium',
  ACCOUNT_WIDGET_OPEN: 'accountWidgetOpen',
  LARGE: 'large',
  ACTION_SELECTOR: 'actionSelector',
};
_vc.WIDGET_MASK_TYPE = {
  LOGO: 'LOGO',
  PHOTO: 'PHOTO',
  LETS_TALK: 'LETS_TALK',
  SOLO_CHAT: 'SOLO_CHAT',
  ANIMATED_PHOTO: 'ANIMATED_PHOTO',
  // VIDEO: 'VIDEO',
};
_vc.WIDGET_MASK_DIMENSION = {
  LOGO: {width: 90, height: 54},
  PHOTO: {width: 70, height: 70},
  LETS_TALK: {width: 47, height: 47},
  SOLO_CHAT: {width: 76, height: 76},
  ANIMATED_PHOTO: {width: 126, height: 126},
};
_vc.WIDGET_INTERACTION_MODE = {
  TEAM_LIST: 'TEAM_LIST',
  LIST_AND_CHAT: 'LIST_AND_CHAT',
  TEAM_WIDGET: 'TEAM_WIDGET',
};
_vc.WIDGET_BG_ORIGIN = {
  CONSOLTO: 'CONSOLTO',
  USER_UPLOAD: 'USER_UPLOAD',
};
_vc.WIDGET_BG_PATTERN_NAME = {
  NONE: 'NONE',
  ORBITAL: 'ORBITAL',
  WIREFRAME: 'WIREFRAME',
  WAVEFORM: 'WAVEFORM',
  BUBBLES: 'BUBBLES',
  BLURBOX: 'BLURBOX',
  HEXAFLOW: 'HEXAFLOW',
};

/////////////    ANALYTICS EVENTS END   /////////

/// reason for maintaining two sets of notificiation_types (key, value) is that we want the mongoDb database model structions to use camelCase while enum names should use capital
_vc.NOTIFICATION_TYPES = {
  SCHEDULING_EMAIL_NOTIFICATION: 'schedulingEmailNotifications',
  CALL_SMS_NOTIFICATION: 'callSmsNotification',
  CHAT_SMS_NOTIFICATION: 'chatSmsNotification',
  CHAT_EMAIL_NOTIFICATION: 'chatEmailNotification',
  INFO_COLLECTOR_SMS_NOTIFICATION: 'infoCollectorSmsNotification',
  INFO_COLLECTOR_EMAIL_NOTIFICATION: 'infoCollectorEmailNotification',
};

_vc.NOTIFICATION_TYPES_KEYS = {
  SCHEDULING_EMAIL_NOTIFICATION: 'SCHEDULING_EMAIL_NOTIFICATION',
  CALL_SMS_NOTIFICATION: 'CALL_SMS_NOTIFICATION',
  CHAT_SMS_NOTIFICATION: 'CHAT_SMS_NOTIFICATION',
  CHAT_EMAIL_NOTIFICATION: 'CHAT_EMAIL_NOTIFICATION',
  INFO_COLLECTOR_SMS_NOTIFICATION: 'INFO_COLLECTOR_SMS_NOTIFICATION',
  INFO_COLLECTOR_EMAIL_NOTIFICATION: 'INFO_COLLECTOR_EMAIL_NOTIFICATION',
};
_vc.CHAT_AUTO_RESPONDER = {
  DEFAULT_TIME_BETWEEN_AUTO_CHATS: 1000 * 60 * 60 * 24 * 0.5,
  DEFAULT_TIME_BEFORE_AUTO_CHAT_POPS: 1000 * 14,
  DEFAULT_MENTOR_NOT_RESPONDED_MESSAGE:
    "Hi, I'm temporarily not available. Leave your details below and I'll get back to you as soon as I can",
  DEFAULT_TIME_TILL_NON_RESPONSE_MESSAGE: 25 * 1000,
};
_vc.TEAM_ONE_ON_ONE_ROOM_INFO_REMOVAL_TIME = 1000 * 60 * 60 * 3;
_vc.WIDGET_STRINGS = {
  UrlSpliter: _vc.DASH,
  WidgetUrl: _vc.DASH + 'expertWidget/',
};

_vc.WIDGET_EDITABLE_TEXTS = {
  PRE_WIDGET_TEXT: 'PRE_WIDGET_TEXT',
  WHATSAPP_INITIAL_MSG_TEXT: 'WHATSAPP_INITIAL_MSG_TEXT',
  CHAT_WITH_US: 'CHAT_WITH_US',
};

_vc.WIDGET_LOCATION = {
  BOTTOM_LEFT: 'BOTTOM_LEFT',
  BOTTOM_CENTER: 'BOTTOM_CENTER',
  BOTTOM_RIGHT: 'BOTTOM_RIGHT',
};

_vc.WIDGET_POSITIONING = {
  MIN_DISTANCE: -200,
  MAX_DISTANCE: 200,
  DEFAULT_HORIZONTAL_DISTANCE: 20,
  DEFAULT_VERTICAL_DISTANCE: 20,
};

_vc.WIDGET_STYLE_SIZE = {
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE',
};

_vc.WIDGET_APP_TYPES = {
  TEXT_CHAT: 'TEXT_CHAT',
  WEBCALL: 'WEBCALL',
  WHATSAPP: 'WHATSAPP',
  FB_MESSENGER: 'FB_MESSENGER',
  CUSTOM_LINK: 'CUSTOM_LINK',
  POST_CALL_FAIL: 'POST_CALL_FAIL',
  POST_FORM_SUBMIT: 'POST_FORM_SUBMIT',
  SCHEDULE_MEETING: 'SCHEDULE_MEETING',
  INFO_COLLECTOR: 'INFO_COLLECTOR',
  PHONE_CALL: 'PHONE_CALL',
  NONE: 'NONE',
  ACTION_SELECTOR: 'ACTION_SELECTOR',
};

_vc.WIDGETS_REDIRECT_TYPES = {
  POST_CALL_FAIL_WIDGETS: 'postCallFailWidgets',
  POST_FORM_SUBMIT_WIDGETS: 'postFormSubmitWidgets',
};

_vc.SCREEN_SIZE = {
  MOBILE: 'MOBILE',
  DESKTOP: 'DESKTOP',
};

_vc.RESPONSIVE_BREAKPOINTS = {
  MOBILE: 768,
};

_vc.DYNAMIC_FORM_TEMPLATE_TYPE = {
  PRE_CHAT: 'PRE_CHAT',
  PRE_CALL: 'PRE_CALL',
  CONTACT_FORM: 'CONTACT_FORM',
  PER_SCHEDULE: 'PER_SCHEDULE',
  // DURING_CALL: 'DURING_CALL',
};

_vc.QUESTION_TYPE = {
  CONSENT: 'CONSENT',
  SINGLE_LINE: 'SINGLE_LINE',
  MULTI_LINE: 'MULTI_LINE',
  NUMBER: 'NUMBER',
  EMAIL: 'EMAIL',
  PHONE_NUMBER: 'PHONE_NUMBER',
  // MULTI_OPTION: "MULTI_OPTION",
};

_vc.WIDGET_APP_HEADER_TITLE_TYPES = {
  TEXT_CHAT: 'TEXT_CHAT_HEADER_TEXT',
  WEBCALL: 'WEBCALL_HEADER_TEXT',
  WHATSAPP: 'WHATSAPP_HEADER_TEXT',
  FB_MESSENGER: 'FB_MESSENGER_HEADER_TEXT',
  CUSTOM_LINK: 'CUSTOM_LINK_HEADER_TEXT',
  SCHEDULE_MEETING: 'SCHEDULE_MEETING_HEADER_TEXT',
  INFO_COLLECTOR: 'INFO_COLLECTOR_HEADER_TEXT',
  PHONE_CALL: 'PHONE_CALL_HEADER_TEXT',
  ACTION_SELECTOR: 'ACTION_SELECTOR_HEADER_TEXT',
};
_vc.WIDGET_APP_CTA_TYPES = {
  TEXT_CHAT: 'TEXT_CHAT_CTA_TEXT',
  WEBCALL: 'WEBCALL_CTA_TEXT',
  WHATSAPP: 'WHATSAPP_CTA_TEXT',
  FB_MESSENGER: 'FB_MESSENGER_CTA_TEXT',
  CUSTOM_LINK: 'CUSTOM_LINK_CTA_TEXT',
  SCHEDULE_MEETING: 'SCHEDULE_MEETING_CTA_TEXT',
  INFO_COLLECTOR: 'INFO_COLLECTOR_CTA_TEXT',
  PHONE_CALL: 'PHONE_CALL_CTA_TEXT',
};
_vc.WIDGET_APP_CTA_TYPES_BTN_TEXT = {
  TEXT_CHAT: 'TEXT_CHAT_CTA_BTN_TEXT',
  WEBCALL: 'WEBCALL_CTA_BTN_TEXT',
  AUDIO_WEBCALL: 'AUDIO_CALL_CTA_BTN_TEXT',
  WHATSAPP: 'WHATSAPP_CTA_BTN_TEXT',
  FB_MESSENGER: 'FB_MESSENGER_CTA_BTN_TEXT',
  CUSTOM_LINK: 'CUSTOM_LINK_CTA_BTN_TEXT',
  SCHEDULE_MEETING: 'SCHEDULE_MEETING_CTA_BTN_TEXT',
  INFO_COLLECTOR: 'INFO_COLLECTOR_CTA_BTN_TEXT',
  PHONE_CALL: 'PHONE_CALL_CTA_BTN_TEXT',
};
_vc.WIDGET_ACTION_SELECTOR_TABS_TEXT = {
  CHANNEL_TEXT_CHAT: 'CHANNEL_TEXT_CHAT',
  CHANNEL_WEBCALL: 'CHANNEL_WEBCALL',
  CHANNEL_SCHEDULE_MEETING: 'CHANNEL_SCHEDULE_MEETING',
  CHANNEL_WHATSAPP: 'CHANNEL_WHATSAPP',
  CHANNEL_FB_MESSENGER: 'CHANNEL_FB_MESSENGER',
  CHANNEL_CUSTOM_LINK: 'CHANNEL_CUSTOM_LINK',
  CHANNEL_PHONE_CALL: 'CHANNEL_PHONE_CALL',
  CHANNEL_INFO_COLLECTOR: 'CHANNEL_INFO_COLLECTOR',
};
// _vc.WIDGET_APP_TYPES_BTN_TEXT = {
//   WEBCALL: 'WEBCALL_CTA_BTN_TEXT',
//   AUDIO_WEBCALL: 'AUDIO_WEBCALL_CTA_BTN_TEXT',
//   WHATSAPP: 'WHATSAPP_CTA_BTN_TEXT',
//   FB_MESSENGER: 'FB_MESSENGER_CTA_BTN_TEXT',
//   SCHEDULE_MEETING: 'SCHEDULE_MEETING',
//   INFO_COLLECTOR: 'INFO_COLLECTOR_CTA_BTN_TEXT',
// };

// these routes need authentication
_vc.PRIVATE_ROUTES_PATH = {
  EXPERT_HOME: '/expertHome',
  RESELLER_AGENCY: '/resellerAgency',
  SUB_ACCOUNT: '/subAccount',
};

_vc.EXPERT_HOME_ROUTES_PATH = {
  ACCOUNT_CENTER: '/expertHome/accounts',
  CHAT_CENTER: '/expertHome/chatCenter',
  LEADS: '/expertHome/leads',
  OVERVIEW: '/expertHome/overview',
  PARTNER_ZONE: '/expertHome/partnersZone',
  RESELLER_ADMIN: '/expertHome/resellerAdmin',
  PERSONAL_SETTINGS: '/expertHome/personalSettings',
  SCHEDULING: '/expertHome/calendar',
  WIDGET_CENTER: '/expertHome/widgetCenter',
  INSTANT_AND_SCHEDULED_MEETINGS: '/expertHome/mrsid',
  EXPERT_SETTINGS: '/expertHome/settings',
};
_vc.RESELLER_AGENCY_ROUTES_PATH = {
  OVERVIEW: '/resellerAgency/overview',
  SUB_ACCOUNTS: '/resellerAgency/subAccounts',
};
_vc.SUB_ACCOUNT_ROUTES_PATH = {
  CHAT_CENTER: '/subAccount/chatCenter',
  LEADS: '/subAccount/leads',
  OVERVIEW: '/subAccount/overview',
  SCHEDULING: '/subAccount/calendar',
  EXPERT_SETTINGS: '/subAccount/settings',
};
_vc.GENERIC_NAVIGATION_KEYS = {
  DEFAULT: 'default',
  RESELLER_AGENCY: 'resellerAgency',
};
_vc.TABS_BACKEND_ID = {
  CHAT_CENTER: 'CHAT_CENTER',
  LEADS_CENTER: 'LEADS_CENTER',
  OVERVIEW: 'OVERVIEW',
  RESELLER_ADMIN: 'RESELLER_ADMIN',
  SCHEDULING: 'SCHEDULING',
  EXPERT_SETTINGS: 'EXPERT_SETTINGS',
  WIDGET_CENTER: 'WIDGET_CENTER',
};

_vc.SIDEBAR_NOTIFICATION_TYPES = {
  APPOINTMENT_REQUEST: 'APPOINTMENT_REQUEST',
  APPOINTMENT_REMINDER: 'APPOINTMENT_REMINDER',
  CHAT_MESSAGE: 'CHAT_MESSAGE',
  TASK_OWNER_UPDATE: 'TASK_OWNER_UPDATE',
  MEETING_ROOM_JOIN_REQUEST: 'MEETING_ROOM_JOIN_REQUEST',
  OONI_HANDOFF: 'OONI_HANDOFF',
};
_vc.POPUP_NOTIFICATION_TYPES = {
  LIGHT: 'light',
  DARK: 'dark',
  WARNING: 'warning',
};
_vc.PROGRESS_TOAST_NOTIFICATION_TYPES = {
  CRAWL: 'CRAWL',
  TRAINING: 'TRAINING',
};
_vc.PAGE_TITLE = testEnv ? 'TEST_CO' : 'CONSOLTO';

_vc.WIDGET_ID_TYPE = {
  ACCOUNT: 'ACCOUNT',
  PERSONAL: 'PERSONAL',
};
_vc.ACCOUNT_TYPE = {
  ACCOUNT: 'ACCOUNT',
  PERSONAL: 'PERSONAL',
};
_vc.INTEGRATION_OWNER_OBJECT_TYPE = {
  ACCOUNT: 'ACCOUNT',
  PERSONAL: 'PERSONAL',
  WIDGET: 'WIDGET',
  MENTOR: 'MENTOR',
  AGENCY: 'AGENCY',
};

_vc.VIDEO_CALL_STATE = {
  INIT: 'init',
  CALL_REQUESTED: 'requested',
  JOIN_CALL_REQUESTED: 'joinRequested', // Non-call-reciever side only!
  RECEIVED_CALL_REQUEST: 'requestReceived',
  CALL_ACCEPTED: 'requestAccepted',
  // REQUEST_RESOLVED: 'requestResolved',
  GETTING_VIDEO_FROM_PEER: 'gettingVideoFromPeer',
  SENDING_VIDEO_TO_PEER: 'sendingVideoToPeer',
  CALL_IN_PROGRESS: 'callInProgress',
  PRE_MEETING_ROOM_ENTRANCE: 'preMeetingRoomEntrance',

  // CONNECTION_DESTROYED: 'connectionDestroyed',
  // TERMINATED: 'terminated',
};
_vc.OT_VIDEO_MODE = {
  CALL_INITIATOR: 'CALL_INITIATOR',
  CALL_RECEIVER: 'CALL_RECEIVER',
  MEETING_ROOM: 'MEETING_ROOM',
};
_vc.MEDIA_DEVICE_TYPES = {
  VIDEO_INPUT: 'videoinput',
  AUDIO_INPUT: 'audioinput',
  AUDIO_OUTPUT: 'audiooutput',
};
_vc.ACTIVE_VIDEO_SIZE = {
  TINY: 'tiny',
  SMALL: 'small',
  MEDIUM: 'medium',
  FULL_SCREEN: 'fullScreen',
};
_vc.VIDEO_BACKGROUND_EFFECT_TYPES = {
  NO_BLUR: 'NO_BLUR',
  BACKGROUND_BLUR: 'BACKGROUND_BLUR',
  BACKGROUND_IMAGE: 'BACKGROUND_IMAGE',
};
_vc.ACTIVE_3D_SIZE = {
  TINY: 'tiny',
  SMALL: 'small',
  MEDIUM: 'medium',
  FULL_SCREEN: 'fullScreen',
};
_vc.MEDIA_MESSAGE = {
  MAX_MSG_TIME: 60,
};
_vc.MEDIA_MESSAGE_TYPES = {
  AUDIO: 'AUDIO',
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  FILE: 'FILE',
  OTHER: 'OTHER',
};
_vc.ACTIVE_THREED_SIZE = {
  TINY: 'tiny',
  SMALL: 'small',
  MEDIUM: 'medium',
  FULL_SCREEN: 'fullScreen',
};
_vc.MEDIA_API_MESSAGE_TYPES = {
  AUDIO: 'audio',
  IMAGE: 'image',
  SESSION_INSTANCE: 'sessionInstance',
  FILE: 'file',
  ALL_MEDIA: 'allMedia',
};

_vc.SESSION_MODES = {
  AUDIO_VIDEO: 'AUDIO_VIDEO',
  AUDIO_ONLY: 'AUDIO_ONLY',
  VIDEO_ONLY: 'VIDEO_ONLY',
  SCREEN_SHARE: 'SCREEN_SHARE',
};
_vc.SESSION_MODES_VALUES = {
  AUDIO_VIDEO: 'AUDIO_VIDEO',
  AUDIO_ONLY: 'Audio',
  VIDEO_ONLY: 'Video',
  SCREEN_SHARE: 'SCREEN_SHARE',
};
_vc.C2C_MONEY_TRANSACTION_PAYMENT_FLOW_TYPE = {
  PRE_CALL: 'PRE_CALL',
  PRE_CHAT: 'PRE_CHAT',
  DURING_CHAT: 'DURING_CHAT',
  IN_SCHEDULING: 'IN_SCHEDULING',
  POST_LEAD_COLLECTOR: 'POST_LEAD_COLLECTOR',
};
_vc.C2C_MONEY_TRANSACTION_EVENT_TYPE = {
  INIT: 'INIT',
  PAID: 'PAID',
  REFUNDED: 'REFUNDED',
  CANCEL_REFUND: 'CANCEL_REFUND',

  ERROR: 'ERROR',
};
_vc.C2C_MAX_TRANSACTION_VALUE = 500;
_vc.C2C_CUSTOMER_PAYMENT_SUCCESSFUL_STATUS = 'CUSTOMER_PAYMENT_SUCCESSFUL';
_vc.STRIPE_C2C_ONBOARDING_REDIRECT_PATH = '/stripe-account-onboarding-complete';
_vc.BILLING_PLANS = {
  ENTERPRISE: 'ENTERPRISE',
  GENIUS: 'GENIUS',
  CLEVER: 'CLEVER',
  SMART: 'SMART',
};

_vc.ADDON_TYPES = {
  AI_ACTIVITY_CREDITS: 'AI_ACTIVITY_CREDITS',
  CALL_RECORDINGS: 'CALL_RECORDINGS',
  ALL: 'ALL',
};

_vc.ADDON_NAMES = {
  AI_ACTIVITY_CREDITS: 'AI activity credits',
  CALL_RECORDINGS: 'Call recordings',
};

_vc.ADDON_RECHARGE_TYPES = {
  ONE_TIME: 'ONE_TIME',
  THRESHOLD: 'THRESHOLD',
};
// _vc.BFCM_COUPON = restServerTest
//   ? restServerLocal
//     ? '0uPlScy7'
//     : ''
//   : 'yNlFOmRg'; // 18+60%: VEebF687,  18+50%: 2HpgMCBi, 18+40%: yNlFOmRg
_vc.TRIAL_BILLING_PLAN = {
  name: 'trial',
  amount: '0',
  currency: 'USD',
  numOfAgents: 1,
  billingCycleFrequencyType: 'Months',
  billingCycleFrequencyDuration: 1,
  planDescription: 'Trial billing plan',
  planEnabledFeatures: {
    FORWARD_ANALYTICS_EVENTS: 0,
    WIDGET_STYLE: 0,
    WIDGET_CUSTOMIZED_TEXTS: 0,
    PRE_INTERACTION_FORM: 0,
    CALL_FAIL_ACTIONS: 1,
    PAGE_REGEX: 0,
    WHITE_LABEL: 0,
    SCHEDULING_ADVANCED: 1,
    CUSTOM_BUTTONS: 0,
    MONEY_TRANSFER: 1,
    WEBSITE_API: 0,
    INTEGRATIONS: 0,
    CALL_RECORDING: 5,
    CONFERENCE: 3,
    // OONI_AI: 1,
  },
  planDuration: 'No End',
  isActive: true,
};
_vc.PAYMENT_GATEWAY_TYPES = {
  SHOPIFY: 'SHOPIFY',
  RESELLER: 'RESELLER',
  PAYPAL: 'PAYPAL',
  STRIPE: 'STRIPE',
  PADDLE: 'PADDLE',
};
_vc.PAYER_TO_CONSOLTO_OBJECT_TYPES = {
  ACCOUNT: 'ACCOUNT',
  RESELLER_AGENCY: 'RESELLER_AGENCY',
};
_vc.BILLING_PLAN_FEATURES = {
  FORWARD_ANALYTICS_EVENTS: {
    name: 'FORWARD_ANALYTICS_EVENTS',
    startingPlan: 'CLEVER',
  },
  MONEY_TRANSFER: {name: 'MONEY_TRANSFER', startingPlan: 'GENIUS'},
  WIDGET_STYLE: {name: 'WIDGET_STYLE', startingPlan: 'CLEVER'},
  WIDGET_STYLE_ADVANCED: {
    name: 'WIDGET_STYLE_ADVANCED',
    startingPlan: 'GENIUS',
  },
  WIDGET_CUSTOMIZED_TEXTS: {
    name: 'WIDGET_CUSTOMIZED_TEXTS',
    startingPlan: 'CLEVER',
  },
  PRE_INTERACTION_FORM: {name: 'PRE_INTERACTION_FORM', startingPlan: 'SMART'},
  CALL_FAIL_ACTIONS: {name: 'CALL_FAIL_ACTIONS', startingPlan: 'CLEVER'},
  PAGE_REGEX: {name: 'PAGE_REGEX', startingPlan: 'GENIUS'},
  WHITE_LABEL: {name: 'WHITE_LABEL', startingPlan: 'GENIUS'},
  SCHEDULING_ADVANCED: {name: 'SCHEDULING_ADVANCED', startingPlan: 'GENIUS'},
  CUSTOM_BUTTONS: {name: 'CUSTOM_BUTTONS', startingPlan: 'GENIUS'},
  WEBSITE_API: {name: 'WEBSITE_API', startingPlan: 'GENIUS'},
  INTEGRATIONS: {name: 'INTEGRATIONS', startingPlan: 'GENIUS'},
  CALL_RECORDING: {name: 'CALL_RECORDING', startingPlan: 'GENIUS'},
  CHAT_HISTORY: {name: 'CHAT_HISTORY', startingPlan: 'GENIUS'},
  SHARED_TEAM_COMMUNICATION: {
    name: 'SHARED_TEAM_COMMUNICATION',
    startingPlan: 'CLEVER',
  },
  BYOK: {
    name: 'BYOK',
    startingPlan: 'GENIUS',
  },
};
_vc.EXTRAS = {
  CALL_RECORDING: 'CALL_RECORDING',
  NUM_OF_AGENT: 'NUM_OF_AGENT',
  DOMAIN: 'DOMAIN',
  INTEGRATIONS: 'INTEGRATIONS',
  TRIAL_DAYS: 'TRIAL_DAYS',
  MONEY_TRANSFER: 'MONEY_TRANSFER',
};
_vc.APP_TRIAL_DAYS = 7;

_vc.TOUR_NAMES = {
  OVERVIEW_TAB: 'OVERVIEW_TAB',
  CHAT_CENTER: 'CHAT_CENTER',
  APPOINTMENT_CENTER_MAIN: 'APPOINTMENT_CENTER_MAIN',
  APPOINTMENT_CENTER_HEADER: 'APPOINTMENT_CENTER_HEADER',
  APPOINTMENT_CENTER_NEW_MEETING: 'APPOINTMENT_CENTER_NEW_MEETING',
  APPOINTMENT_CENTER_LARGE_VIEW: 'APPOINTMENT_CENTER_LARGE_VIEW',
  WIDGET_CENTER: 'WIDGET_CENTER',
  ACCOUNT_CENTER: 'ACCOUNT_CENTER',
  PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
  HEADER: 'HEADER',
  FLAG_WIDGET: 'FLAG_WIDGET',
  FIRST_STEPS: 'FIRST_STEPS',
  LEFT_NAVIGATION: 'LEFT_NAVIGATION',
  AGENT_SELECTOR: 'AGENT_SELECTOR',
};

_vc.BOOKING_FLOW_STATES = {
  INIT: 'INIT',
  CREATED: 'CREATED',
  READ: 'READ',
  CONFIRMED: 'CONFIRMED',
  OVERDUE: 'OVERDUE',
  DECLINED: 'DECLINED',
  REBOOKED: 'REBOOKED',
  CANCELLED: 'CANCELLED',
  RESERVED: 'RESERVED',
};
_vc.BOOKING_FLOW_USER_STATES = {
  CREATED: 'CREATED',
  CONFIRMED: 'CONFIRMED',
  DECLINED: 'DECLINED',
  REBOOKED: 'REBOOKED',
  CANCELLED: 'CANCELLED',
};
_vc.BOOKING_FLOW_COMPONENT_TYPES = {
  CANCELLED: 'CANCELLED',
  CONFIRMED: 'CONFIRMED',
  CREATED: 'CREATED',
  DECLINED: 'DECLINED',
  OVERDUE: 'OVERDUE',
  PENDING: 'PENDING',
  REBOOKED: 'REBOOKED',
};
_vc.BOOKING_FLOW_MEETING_TYPES = {
  REMINDER: 'REMINDER',
  MEETING: 'MEETING',
};
_vc.SCHEDULING_NAV_STATES = {
  REQUESTS: 'REQUESTS',
  CALENDAR: 'CALENDAR',
  AGENDA: 'AGENDA',
  SEND_INVITE: 'SEND_INVITE',
  SETTINGS: 'SETTINGS',
  NEW_DESIGN: 'NEW_DESIGN',
};
_vc.SCHEDULING_API_TYPES = {
  CANCEL: 'CANCEL',
  DECLINE: 'DECLINE',
  RESCHEDULE_BY_REQUESTER: 'RESCHEDULE_BY_REQUESTER',
  RESCHEDULE_BY_RECIPIENT: 'RESCHEDULE_BY_RECIPIENT',
};
_vc.CALENDAR_MODES = {
  // MONTH: 'MONTH',
  WEEK: 'WEEK',
  DAY: 'DAY',
};
_vc.SCHEDULING_TAB_TYPES = {
  AGENDA: 'AGENDA',
  EVENTS: 'EVENTS',
  CALENDAR: 'CALENDAR',
  CREATE_NEW_EVENT: 'CREATE_NEW_EVENT',
  MEETING_IN_LARGE_VIEW: 'MEETING_IN_LARGE_VIEW',
};
_vc.SCHEDULING_URL_ACTIONS = {
  VIEW: 'VIEW',
  ACCEPT: 'ACCEPT',
  DECLINE: 'DECLINE',
  REBOOK: 'REBOOK',
};
_vc.START_MEETING_LINK_OPTIONS = {
  HOME_PAGE: 'HOME_PAGE',
  PERSONAL_PAGE: 'PERSONAL_PAGE',
  MEETING_ROOM: 'MEETING_ROOM',
  // OTHER: 'OTHER',
};
_vc.SCHEDULING_MEETING_ORIGIN_TYPES = {
  CONSOLTO: 'CONSOLTO',
  GOOGLE: 'GOOGLE',
  OUTLOOK: 'OUTLOOK',
};

_vc.WIDGET_NAV_STATES = {
  PERSONAL_INFORMATION: 'PERSONAL_INFORMATION',
  AUTOMATIC_MESSAGES: 'AUTOMATIC_MESSAGES',
  COMMUNICATION_APPS: 'COMMUNICATION_APPS',
  STYLE: 'STYLE',
  MONEY_TRANSFER: 'MONEY_TRANSFER',
  INTEGRATIONS: 'INTEGRATIONS',
  ADVANCED_FEATURES: 'ADVANCED_FEATURES',
  INSTALLATION: 'INSTALLATION',
  DYNAMIC_FORMS: 'DYNAMIC_FORMS',
  THREED: 'THREED',
};
_vc.PERSONAL_SETTINGS_NAV_STATES = {
  PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
  BILLING: 'BILLING',
  NOTIFICATIONS: 'NOTIFICATIONS',
  INTEGRATIONS: 'INTEGRATIONS',
  PARTNERSHIPS: 'PARTNERSHIPS',
};
_vc.PERSONAL_SETTINGS_TITLES = {
  PERSONAL_SETTINGS: 'Personal Info',
  BILLING: 'Billing',
  NOTIFICATIONS: 'Notifications',
  INTEGRATIONS: 'Integrations',
};

_vc.ACCOUNT_CENTER_NAV_STATES = {
  ACCOUNT_INFORMATION: 'ACCOUNT_INFORMATION',
  AGENTS: 'AGENTS',
  WIDGET: 'WIDGET',
  STYLE: 'STYLE',
  ADVANCED_FEATURES: 'ADVANCED_FEATURES',
  INTEGRATIONS: 'INTEGRATIONS',
  INSTALLATION: 'INSTALLATION',
};

_vc.WIDGET_TITLES = {
  PERSONAL_INFORMATION: 'General Information',
  AUTOMATIC_MESSAGES: 'Automatic Messages',
  COMMUNICATION_APPS: 'Communication Channels',
  STYLE: 'Custom Styling',
  MONEY_TRANSFER: 'Money Transfer',
  INTEGRATIONS: 'Integrations',
  ADVANCED_FEATURES: 'Advanced Features',
  DYNAMIC_FORMS: 'Form Customization',
  INSTALLATION: 'Single-widget installation',
};

_vc.ACCOUNT_TITLES = {
  ACCOUNT_INFORMATION: 'Team Information',
  AGENTS: 'Team Members',
  WIDGET: 'Widget Setup',
  STYLE: 'Custom Styling',
  ADVANCED_FEATURES: 'Advanced Features',
  INTEGRATIONS: 'Integrations',
  INSTALLATION: 'Team-widget Installation',
};

_vc.ONBOARDING_COMPONENT_IDS = {
  WIDGET: 'widget-on-boarding',
  PERSONAL_PAGE: 'personal-page-on-boarding',
};

_vc.AUDIO_SOUND_TYPES = {
  APPOINTMENT_REMINDER_AUDIO: 'APPOINTMENT_REMINDER_AUDIO',
  CALL_AUDIO: 'CALL_AUDIO',
  CHAT_AUDIO: 'CHAT_AUDIO',
  CUSTOMER_ARRIVAL_AUDIO: 'CUSTOMER_ARRIVAL_AUDIO',
  MID_CALL_JOIN_AUDIO: 'MID_CALL_JOIN_AUDIO',
  HANDOFF_AUDIO: 'HANDOFF_AUDIO',
};

_vc.SCHEDULING_AVAILABLE_TIME_OPTIONS = {
  SPECIFIC_TIME: 'SPECIFIC_TIME',
  ALL_TIME: 'ALL_TIME',
  NO_TIME: 'NO_TIME',
};
_vc.TIME_SLOT_JUMPS = {
  FIVE: 5,
  TEN: 10,
  FIFTEEN: 15,
  TWENTY: 20,
  THIRTY: 30,
  FORTY: 40,
  FORTY_FIVE: 45,
  ONE_HOUR: 60,
  ONE_AND_HALF_HOUR: 90,
  TWO_HOUR: 120,
};
_vc.DEFAULT_TIME_SLOT_JUMP = 30;
_vc.TIME_FORMAT = {
  TWELVE_HOUR: 'TWELVE_HOUR', //AMPM
  TWENTY_FOUR_HOUR: 'TWENTY_FOUR_HOUR',
};
_vc.DEFAULT_TIME_ZONE = 'America/New_York';
_vc.WEEKDAYS_ENUM = {
  SUNDAY: 'SUNDAY',
  MONDAY: 'MONDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY',
  THURSDAY: 'THURSDAY',
  FRIDAY: 'FRIDAY',
  SATURDAY: 'SATURDAY',
};
_vc.WEEKDAYS_INDEX = {
  0: 'SUNDAY',
  1: 'MONDAY',
  2: 'TUESDAY',
  3: 'WEDNESDAY',
  4: 'THURSDAY',
  5: 'FRIDAY',
  6: 'SATURDAY',
};
_vc.MINIMUM_TIME_BEFORE_BOOKING_IN_MIN = {
  NO_RESTRICTION: 0,
  FIFTEEN_MINUTES: 15,
  THIRTY_MINUTES: 30,
  ONE_HOUR: 60,
  ONE_AND_HALF_HOUR: 90,
  TWO_HOURS: 120,
  THREE_HOURS: 180,
  FOUR_HOURS: 240,
  SIX_HOURS: 360,
  EIGHT_HOURS: 480,
  TWELVE_HOURS: 720,
  NEXT_DAY: -1,
};
_vc.PRE_MEETING_JOINING_TIME_IN_MINUTES = 15;

_vc.COMMON_PERIODS = {
  DAY: 1000 * 60 * 60 * 24, // one day millseconds
};
_vc.PAYMENT_TRANSACTION_CURRENCIES = {
  USD: 'USD',
  EUR: 'EURO',
  ILS: 'ILS',
  GBP: 'GBP',
  AUD: 'AUD',
  CAD: 'CAD',
  INR: 'INR',
  // MYR: "MYR",
};
_vc.MARKETING_QUERY_PARAM_NAMES = {
  PLAN: 'plan',
};
_vc.FORWARD_EVENTS = {
  PEER_STATUS: 'PEER_STATUS',
};
_vc.LOCAL_STORAGE_ITEMS = {
  PARTNER_AFFILIATE_INFO_ID: 'prtafid',
  // MARKETING_PARAMETERS: "marpar",
  MARKETING_QUERY: 'marQuery',
  PLAN_FROM_URL: 'planFromUrl',
  CONSOLTO_USER_ID: 'cnslt_uid', // for Cookie only.
  VIDEO_BACKGROUND: 'videoBg',
  MENTOR_PILLS_VISIBLE: 'mentorPillsVisible',
  LAST_DATA_PERMISSION_REQ_TIME: 'lastDataPermissionReqTime',
  CUSTOMER_LAST_MSG_WITH_CHAT_ROOM: 'clmwc',
  MENTOR_LAST_MSG_WITH_CHAT_ROOM: 'mlmwc',
  TEAM_ONE_ON_ONE_ROOM_INFO: 'teamOneOnOneRoomInfo',
  SELECTED_MENTOR_IDS: 'selectedMentorIds',
  TAKE_OWNERSHIP_OF_CHAT_ROOM: 'takeOwnershipOfChatRoom',
  IMPERSONATED_USER_ID: 'impersonatedUserId',
};
_vc.UTM_SOURCES = {
  CONSOLTO: 'consolto',
};
_vc.LOADER_TYPES = {
  LOADING: 'Loading...',
  LOAD_MORE: 'Load more',
  NO_DATA_FOUND: 'Finished loading. No media results.',
};
_vc.UTM_MEDIUMS = {
  SCHEDULING: 'scheduling',
  PERSONAL_PAGE: 'personal_page',
  WIDGET: 'widget',
  MEDIA: 'media',
  MEETING_ROOM: 'meeting_room', //instant meeting
};
_vc.UTM_CAMPAIGNS = {
  SCHEDULING_BTN: 'sch_btn',
  PERSONAL_PAGE_BTN: 'pp_get_consolto',
  WIDGET_BTN: 'wdg_get_consolto',
  MEDIA_BTN: 'media_pg_btn',
  MEETING_ROOM_BTN: 'mr_get_consolto',
};
_vc.ACTION_CLICK_INITIATOR = {
  FOOTER: 'FOOTER',
};
_vc.TRIGGER_ACTIONS = {
  SCHEDULING: 'scheduling',
  AUDIO_CALL: 'audiocall',
  VIDEO_CALL: 'videocall',
  TEXT_CHAT: 'textchat',
  OPEN_WIDGET: 'openwidget',
  CONTACT_FORM: 'form',
  FB_MESSENGER: 'fbmessenger',
  CUSTOM_LINK: 'customlink',
  WHATSAPP: 'whatsapp',
  PHONE_CALL: 'phonecall',
};
_vc.MEETING_ROOM_ENTRANCE_CONDITIONS = {
  MENTOR_ACCEPT: 'MENTOR_ACCEPT',
  NO_CONDITION: 'NO_CONDITION',
};
_vc.MEETING_ROOM_FLOW_TYPES = {
  INSTANT: 'INSTANT',
  SCHEDULING: 'SCHEDULING',
};

_vc.NATIVE_FLAG_WIDGET_VISIBILITY_TYPES = {
  BOTTOM_RIGHT: 'BOTTOM_RIGHT',
  BOTTOM_RIGHT_WITH_MARGIN: 'BOTTOM_RIGHT_WITH_MARGIN',
  HIDDEN: 'HIDDEN',
};

_vc.AUTO_CANCEL_TIME_FOR_AUTOMATED_CALLS = 60 * 1000;
_vc.AUTO_CANCEL_TIME_FOR_SCHEDULED_CALLS = 180 * 1000;

_vc.WIDGET_MODES = {
  MASK_MODE: 'mask',
  SINGLE_EXPERT_MODE: 'singleexpert',
  ACCOUNT_MODE: 'account',
  DIRECTORY: 'directory',
  HIDDEN_MODE: 'hidden',
};
_vc.AUTO_CANCEL_TIME_FOR_WEB_CALL_NOTIFICATION = 4 * 1000;
_vc.MARKETING_EVENT_TYPES = {
  MARKETING_PARAMS_UPDATE: 'MARKETING_PARAMS_UPDATE',
  USER_INSTALLED_PLUGIN_ON_WEBSITE: 'USER_INSTALLED_PLUGIN_ON_WEBSITE',
  USER_USED_CALL: 'USER_USED_CALL',
  USER_USED_CHAT: 'USER_USED_CHAT',
};
_vc.WIDGET_GRADIENT_DIRECTION = '96deg';
_vc.WIDGET_APP_CTRL_STYLES = {
  closedWidgetType: _vc.WIDGET_MASK_TYPE.LOGO,
};
_vc.STYLE_KEYS_EXCLUDED_FROM_STRINGIFY = [
  'bgPatternDto',
  'widgetHorizontalDistance',
  'widgetVerticalDistance',
];
_vc.MAIN_THEME = {
  CONSOLTO_DARK: {
    type: 'CONSOLTO_DARK',
    themePrimaryFgColor: '#2d2756',
    themePrimaryBgColor: '#ffffff',
    themeSecondaryFgColor: '#ffffff',
    themeSecondaryBgColor: '#2d2756',
  },
  GREEN: {
    type: 'GREEN',
    themePrimaryFgColor: '#00BC5E',
    themePrimaryBgColor: '#ffffff',
    themeSecondaryFgColor: '#ffffff',
    themeSecondaryBgColor: '#00BC5E',
  },
  BLUE: {
    type: 'BLUE',
    themePrimaryFgColor: '#2d2756',
    themePrimaryBgColor: '#ffffff',
    themeSecondaryFgColor: '#ffffff',
    themeSecondaryBgColor: '#2961fa',
  },
  ORANGE: {
    type: 'ORANGE',
    themeSecondaryFgColor: '#2d2756',
    themeSecondaryBgColor: '#f6b805',
    themePrimaryFgColor: '#2d2756',
    themePrimaryBgColor: '#ffffff',
  },
  CONSOLTO_LITE: {
    type: 'CONSOLTO_LITE',
    themePrimaryFgColor: '#2d2756',
    themePrimaryBgColor: '#ffffff',
    themeSecondaryFgColor: '#ffffff',
    themeSecondaryBgColor: `linear-gradient(${_vc.WIDGET_GRADIENT_DIRECTION}, #2961fa, #183994)`,
  },
  RED: {
    type: 'RED',
    themePrimaryFgColor: '#2d2756',
    themePrimaryBgColor: '#ffffff',
    themeSecondaryFgColor: '#ffffff',
    themeSecondaryBgColor: `linear-gradient(${_vc.WIDGET_GRADIENT_DIRECTION}, #da0d00, #740000)`,
  },
  CONSOLTO_PURPLE: {
    type: 'CONSOLTO_PURPLE',
    themePrimaryFgColor: '#2d2756',
    themePrimaryBgColor: '#ffffff',
    themeSecondaryFgColor: '#ffffff',
    themeSecondaryBgColor: `linear-gradient(${_vc.WIDGET_GRADIENT_DIRECTION}, #8B53CC, #000CEE)`,
  },
};
_vc.WIDGET_CUSTOMIZATION_STYLING = {
  bgPatternDto: {
    type: _vc.WIDGET_BG_ORIGIN.CONSOLTO,
    patternName: _vc.WIDGET_BG_PATTERN_NAME.WAVEFORM,
  },
  locationOnScreen: _vc.WIDGET_LOCATION.BOTTOM_RIGHT,
  widgetSize: _vc.WIDGET_STYLE_SIZE.MEDIUM,
  themePreset: _vc.MAIN_THEME.CONSOLTO_LITE.type,
  widgetBackgroundColor: '#2961fa',
  widgetMaskTextColor: '#ffffff',
  themeSecondaryFgColor: '#ffffff',
  themeSecondaryBgColor: '#2961fa',
  themePrimaryFgColor: '#2D2756',
  themePrimaryBgColor: '#ffffff',
  widgetHorizontalDistance: _vc.WIDGET_POSITIONING.DEFAULT_HORIZONTAL_DISTANCE,
  widgetVerticalDistance: _vc.WIDGET_POSITIONING.DEFAULT_VERTICAL_DISTANCE,
};
_vc.TEAM_CUSTOMIZATION_STYLING = {
  primaryBackgroundColor: '#ffffff',
  secondaryBackgroundColor: '#2961fa',
  primaryTextColor: '#2d2756',
  secondaryTextColor: '#aaaaaa',
  ctaBtnTextColor: '#2d2756',
  ctaBtnSecondaryTextColor: '#aaaaaa', // '#2D275680', // opacity  0.5
  ctaBtnColor: '#ffffff',
};
_vc.MENTOR_CUSTOMIZATION_STYLING = {
  primaryBackgroundColor: '#ffffff',
  primaryTextColor: '#2d2756',
  secondaryTextColor: '#aaaaaa', //'#2d27566e', // opacity 0.43

  ctaBtnColor: '#2961fa',
  ctaBtnTextColor: '#ffffff',

  peerBubbleBorderColor: '#2d2756f6', //opacity 0.96
  peerBubbleBorderThickness: 0,
  peerBubbleFillColor: '#2961fa33', // opacity 0.13
  peerBubbleTextColor: '#2D2756',

  myBubbleBorderColor: '#2d2756f6', //opacity 0.96
  myBubbleBorderThickness: 0,
  myBubbleFillColor: '#2961fa',
  myBubbleTextColor: '#ffffff',

  systemBubbleBorderColor: '#aaaaaa', //'#2d27566e', // opacity 0.43
  systemBubbleBorderThickness: 0,
  systemBubbleFillColor: '#ffffff',
  systemBubbleTextColor: '#2961fa',

  inputFieldBubbleBorderColor: '#2d275618', //opacity 0.09
  inputFieldBubbleBorderThickness: 1,
  inputFieldBubbleFillColor: '#ffffff',
  inputFieldBubbleTextColor: '#2D2756',

  inputHazardTextColor: '#fd0061',
};

_vc.APPSUMO_ID = testEnv
  ? '60950497260ed70d541bc52b'
  : '6097a40ac0265906d0e508c2';

_vc.CHAT_HEADER = {
  TEXT_CHAT: 'Chat',
  WEBCALL: 'Video Call',
  WHATSAPP: 'Whatsapp',
  FB_MESSENGER: 'Facebook Messanger',
  CUSTOM_LINK: 'Contact Us',
  POST_CALL_FAIL: 'Video Call',
  SCHEDULE_MEETING: 'Schedule Meeting',
  INFO_COLLECTOR: 'Contact Form',
  PHONE_CALL: 'Phone Call',
  NONE: 'NONE',
  ACTION_SELECTOR: 'Welcome',
};

_vc.PAYMENT_GATEWAY_TYPE = {
  STRIPE: 'STRIPE',
  PAYPAL: 'PAYPAL',
  RESELLER: 'RESELLER',
};

_vc.PAYMENT_STATUS = {
  REFUNDED: 'REFUNDED',
  DENIED: 'DENIED',
  ACCEPTED: 'ACCEPTED',
};

_vc.SUBSCRIPTION_TYPE = {
  NEW: 'new_subscription',
  MODIFY: 'modify_subscription',
};

_vc.EDITABLE_TEXTS = {
  PRE_CHAT_FORM_TITLE: 'PRE_CHAT_FORM_TITLE',
  PRE_CALL_FORM_TITLE: 'PRE_CALL_FORM_TITLE',
  PRE_CHAT_FORM_SUCCESS_MESSAGE: 'PRE_CHAT_FORM_SUCCESS_MESSAGE',
  PRE_CHAT_FORM_CTA_BTN_TEXT: 'PRE_CHAT_FORM_CTA_BTN_TEXT',
  PER_SCHEDULE_FORM_TITLE: 'PER_SCHEDULE_FORM_TITLE',
  CONTACT_FORM_FORM_TITLE: 'CONTACT_FORM_FORM_TITLE',
};
_vc.FRILL_ID = '93fb9ff9-3b2e-4e8b-99e2-9c9b6dab9da6';
_vc.DOUBLE_CLICK_DELAY = 250;

_vc.PERMISSION_TYPES = {
  CAMERA: 'camera',
  MICROPHONE: 'microphone',
};
_vc.PERMISSION_STATUS = {
  GRANTED: 'granted',
  PROMPT: 'prompt',
  DENIED: 'denied',
  NOT_SUPPORTED: 'notSupported',
};
//these messages are shown when OS level permission is not provided for camera/mic
_vc.PERMISSION_ERROR_MSG = [
  {browserList: ['chrome', 'opera'], errMsg: 'Permission denied by system'},
  {browserList: ['firefox'], errMsg: 'The object can not be found here.'},
];

_vc.SWITCH_STATES = {
  DISABLED: 'disabled',
  ON: 'on',
  OFF: 'off',
};

_vc.DEFAULT_TABLE_ROW_HEIGHT = 48; //aligned with et-v2-table-row-container height

_vc.PILL_TYPES = {
  ACTIVE: 'ACTIVE',
  BETA: 'BETA',
  DELETE: 'DELETE',
  IN_ACTIVE: 'IN_ACTIVE',
  NEW: 'NEW',
  PRIMARY: 'PRIMARY',
  UPDATE: 'UPDATE',
  AI_MODE_ON: 'AI_MODE_ON',
};

_vc.LINE_SEPARATOR_ORIENTATIONS = {
  HORIZONTAL: 'HORIZONTAL',
  VERTICAL: 'VERTICAL',
};

_vc.PRIVATE_DATA_ACCESS_STATES = {
  PENDING: 'PENDING',
  REQUEST: 'REQUEST',
  GRANTED: 'GRANTED',
};

_vc.COLLAPSIBLE_BAR_DIRECTION = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
};

_vc.TRANSITION_ANIMATIONS_TYPES = {
  TRANSITION_TO_MENTOR_CHAT: 'TRANSITION_TO_MENTOR_CHAT',
  TRANSITION_TO_MENTOR_CHAT_CLOSE: 'TRANSITION_TO_MENTOR_CHAT_CLOSE',
  TRANSITION_TO_TEAM_CHAT: 'TRANSITION_TO_TEAM_CHAT',
  TRANSITION_TO_TEAM_CHAT_CLOSE: 'TRANSITION_TO_TEAM_CHAT_CLOSE',
  NO_ANIMATION: 'NO_ANIMATION',
};

_vc.TOAST_COMPONENT_TYPES = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  PROGRESS: 'PROGRESS',
};

_vc.TOAST_MESSAGE_TIMES = {
  MIN_TIME: 3 * 1000, // aligned with et-v2-toast-component-wrap
  LONG_TIME: 30 * 1000, // for QA from chat flow
  MAX_TIME: 60 * 1000, // aligned with et-v2-toast-component-wrap-sticky
};

_vc.AUTO_TEXT_TYPER_COMPONENT_TYPES = {
  CHARACTER: 'CHARACTER',
  WORD: 'WORD',
};

_vc.BACKOFFICE_CONFIGURATION = {
  ADMIN_SINGLE_MODE: 'ADMIN_SINGLE_MODE',
  ADMIN_MULTI_MODE: 'ADMIN_MULTI_MODE',
  NON_ADMIN_SINGLE_MODE: 'NON_ADMIN_SINGLE_MODE',
  NON_ADMIN_MULTI_MODE: 'NON_ADMIN_MULTI_MODE',
  NON_ADMIN_EMPTY_WIDGET: 'NON_ADMIN_EMPTY_WIDGET', //non admin, no widget assign to him
  TEAM_ADMIN_SINGLE_MODE: 'TEAM_ADMIN_SINGLE_MODE',
  TEAM_ADMIN_MULTI_MODE: 'TEAM_ADMIN_MULTI_MODE',
  FIRST_RESPONDER_SINGLE_MODE: 'FIRST_RESPONDER_SINGLE_MODE',
  FIRST_RESPONDER_MULTI_MODE: 'FIRST_RESPONDER_MULTI_MODE',
};

_vc.WIDGET_PRODUCTS_TYPES = {
  WIDGET: 'WIDGET',
  PERSONAL_PAGE: 'PERSONAL_PAGE',
  DEMO: 'DEMO',
};
_vc.EXPERT_SETTINGS_TAB_MODES = {
  WIDGET: 'WIDGET',
  AGENT: 'AGENT',
};

_vc.EXPERT_SETTINGS_TAB_MODES = {
  WIDGET: 'WIDGET',
  AGENT: 'AGENT',
};

_vc.MENTOR_ACCESS_RIGHT_TYPES = {
  CHAT_ROOM: 'CHAT_ROOM',
  PROFILE_SECTION: 'PROFILE_SECTION',
};

_vc.SHIMMER_COMPONENT_TYPES = {
  OVERVIEW_AGENDA: 'OVERVIEW_AGENDA',
  OVERVIEW_VOICE_MESSAGES: 'OVERVIEW_VOICE_MESSAGES',
  OVERVIEW_UNREAD_MESSAGES: 'OVERVIEW_UNREAD_MESSAGES',
  CHAT_CENTER_CHAT_LIST: 'CHAT_CENTER_CHAT_LIST',
  CHAT_CENTER_CHAT_CONTAINER: 'CHAT_CENTER_CHAT_CONTAINER',
  CLIENT_CHAT_CONTAINER: 'CLIENT_CHAT_CONTAINER',
  CHAT_CENTER_PROFILE_CONTAINER: 'CHAT_CENTER_PROFILE_CONTAINER',
  LEADS: 'LEADS',
  LEADS_FORM: 'LEADS_FORM',
  DATE_PICKER: 'DATE_PICKER',
  AI_HANDOFF_ACTIONS: 'AI_HANDOFF_ACTIONS',
  CHAT_ROOM_TASK_OWNER: 'CHAT_ROOM_TASK_OWNER',
  SESSION_INSTANCE_CHAT: 'SESSION_INSTANCE_CHAT',
  FLOIK: 'FLOIK',
  MEDIA_TAB: 'MEDIA_TAB',
  EMAIL_CUSTOMIZATION_PREVIEW: 'EMAIL_CUSTOMIZATION_PREVIEW',
  PARTNERSHIPS: 'PARTNERSHIPS',
  RESELLER_ADMIN: 'RESELLER_ADMIN',
  RESELLER_AGENCY_OVERVIEW: 'RESELLER_AGENCY_OVERVIEW',
  RESELLER_AGENCY_USERS: 'RESELLER_AGENCY_USERS',
  RESELLER_AGENCY_SUB_ACCOUNTS: 'RESELLER_AGENCY_SUB_ACCOUNTS',
  RESELLER_CURRENT_PLAN: 'RESELLER_CURRENT_PLAN',
  THREED_WIDGET: 'THREED_WIDGET',
  THREED_FILE_SETTINGS: 'THREED_FILE_SETTINGS',
};
_vc.CNAME_INSTANCE_DNS_RECORD_TYPES = {
  CNAME: 'CNAME',
  TXT_HOST: 'TXT_HOST',
  TXT_CERTIFICATE: 'TXT_CERTIFICATE',
};
_vc.CNAME_INSTANCE_DNS_RECORD_VALIDATION_STATUS = {
  INIT: 'INIT',
  PENDING: 'PENDING',
  ERROR: 'ERROR',
  PASS: 'PASS',
};
_vc.CNAME_INSTANCE_OBJECT_TYPE = {
  ACCOUNT: 'ACCOUNT',
  AGENCY: 'AGENCY',
  AGENCY_CUSTOMER_SIDE: 'AGENCY_CUSTOMER_SIDE',
};
_vc.SPINNER_SIZE = {
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE',
};
_vc.SPINNER_COLOR = {
  WHITE: 'WHITE',
  BLUE: 'BLUE',
};
_vc.HANDOFF_COMPONENT_TYPES = {
  TEAM_CHAT: 'TEAM_CHAT',
  ONE_ON_ONE_CHAT: 'ONE_ON_ONE_CHAT',
  CALL: 'CALL',
};
_vc.ID_PREFIX = {
  CHATBOX: 'chatbox',
  SITE_GUEST: 'site-guest',
};
_vc.MARKETING_ELEMENTS = {
  NONE: 'NONE',
  SPLASH_SCREEN: 'SPLASH_SCREEN',
  ONBOARDING_FLOW: 'ONBOARDING_FLOW',
  PRODUCT_TOUR: 'PRODUCT_TOUR', // walkme
  FRILL_COMPONENT: 'FRILL_COMPONENT',
};
_vc.MARKETING_ELEMENT_STATUS = {
  INIT: 'INIT',
  ACTIVE: 'ACTIVE',
  DONE: 'DONE',
};
_vc.CLOUDINARY_IMAGE_MANIPULATIONS = {
  WIDGET_MASK_IMAGE: 'q_auto:eco,c_fit,h_300,w_300',
  WIDGET_MASK_VIDEO: 'q_auto:eco,du_5,c_fit,h_300,w_300',
};
_vc.AUTH_REDIRECT_PATH_TYPE = {
  OUTLOOK: 'outlook',
  GOOGLE_EMAIL: 'googleEmail',
};
_vc.GOOGLE_EMAIL_AUTH_REDIRECT_PATH = '/gmail-auth-callback';
_vc.ACTIVATION_ROUTES = {
  APPSUMO: '/appsumo-activation',
  AGENCY_CUSTOMER: '/agency-customer-activation',
  AGENCY_MEMBER: '/agency-member-activation',
};
_vc.REGISTRATION_FLOW_TYPES = {
  STANDARD: 'STANDARD',
  APPSUMO: 'APPSUMO',
  AGENCY_CUSTOMER: 'AGENCY_CUSTOMER',
  AGENCY_MEMBER: 'AGENCY_MEMBER',
};
_vc.OUTLOOK_AUTH_REDIRECT_PATH = '/outlook-auth-callback';
_vc.BETA_FEATURES = {
  PAY_PER_LEAD: 'PAY_PER_LEAD',
};
_vc.AI_ASSISTANT_NAME = 'OONI AI';
_vc.OONI_AI_ACTIONS = {
  // linked to chatMessageDto.metaData.ooniAiAction
  COMPLETION_PENDING: 'COMPLETION_PENDING', // OONI started to work on the generate completion
  COMPLETION_SUCCESS: 'COMPLETION_SUCCESS', // OONI finished the generate completion flow
  COMPLETION_FAILURE: 'COMPLETION_FAILURE', // some error occurred before completion flow was completed
  COMPLETION_STOPPED: 'COMPLETION_STOPPED', // generate completion is stopped by customer
  HANDOFF_FLOW_START: 'HANDOFF_FLOW_START', // handoff flow started
};
_vc.CHAT_HANDOFF_FLOW_STATUS = {
  // linked to chatHandoffFlow
  HANDOFF_REQUESTED: 'HANDOFF_REQUESTED',
  ACTION_SELECTED: 'ACTION_SELECTED',
  COLD_HANDOFF_DONE: 'COLD_HANDOFF_DONE',
  HOT_HANDOFF_IN_PROGRESS: 'HOT_HANDOFF_IN_PROGRESS',
  HOT_HANDOFF_FAILED: 'HOT_HANDOFF_FAILED',
  HOT_HANDOFF_SUCCEEDED: 'HOT_HANDOFF_SUCCEEDED',
};
_vc.HOT_HANDOFF_WAIT_TIME_SECONDS = 45;

_vc.KBR_TYPES = {FILE: 'FILE', QA: 'QA', URL: 'URL'};
_vc.KBR_FILE_TYPES = {
  PDF: 'pdf',
  DOC: 'doc',
  TXT: 'txt',
  DOCX: 'docx',
  CSV: 'csv',
  XLSX: 'xlsx',
};
_vc.KBR_STATUSES = {
  INIT: 'INIT',
  DELETED: 'DELETED',
  PENDING_DELETION: 'PENDING_DELETION',
  PENDING_TRAINING: 'PENDING_TRAINING',
  TRAINED: 'TRAINED',
  UPLOADING: 'UPLOADING',
};
_vc.KBR_QA_STATUS = {
  PROPOSED: 'PROPOSED',
  ACCEPTED: 'ACCEPTED',
};
_vc.KB_TRAINING_STATUSES = {
  PENDING_TRAINING: 'PENDING_TRAINING',
  TRAINING_FLOW_ACTIVE: 'TRAINING_FLOW_ACTIVE',
  TRAINED: 'TRAINED',
};
// todo 1720 : Ilan/Jashan : update the tooltip texts
_vc.KBR_PILL_INFO = {
  INIT: {
    pillType: _vc.PILL_TYPES.PRIMARY,
    pillTxt: 'PENDING TRAINING',
    toolTipTxt: 'This knowledge-base resource is ready to be trained.',
  },
  DELETED: {
    pillType: _vc.PILL_TYPES.DELETE,
    pillTxt: _vc.KBR_STATUSES.DELETED,
    toolTipTxt: 'This knowledge-base resource has been deleted. ',
  },
  PENDING_DELETION: {
    pillType: _vc.PILL_TYPES.IN_ACTIVE,
    pillTxt: 'PENDING DELETION',
    toolTipTxt:
      'This knowledge-base resource is pending deletion. Train the AI to remove it from the dataset.',
  },
  PENDING_TRAINING: {
    pillType: _vc.PILL_TYPES.IN_ACTIVE,
    pillTxt: 'PENDING TRAINING',
    toolTipTxt:
      'This knowledge-base resource is pending training. Train the AI to include it in the dataset.',
  },
  PROPOSED: {
    pillType: _vc.PILL_TYPES.PRIMARY,
    pillTxt: _vc.KBR_QA_STATUS.PROPOSED,
    toolTipTxt:
      'This Q&A resource has been proposed for training. Please accept it for it to be added to the dataset. ',
  },
  TRAINED: {
    pillType: _vc.PILL_TYPES.ACTIVE,
    pillTxt: _vc.KBR_STATUSES.TRAINED,
    toolTipTxt:
      'This knowledge-base resource has been trained. Ooni AI is responding to customers using this resource.',
  },
  UPLOADING: {
    pillType: _vc.PILL_TYPES.IN_ACTIVE,
    pillTxt: _vc.KBR_STATUSES.UPLOADING,
    toolTipTxt: 'This knowledge-base resource is currently being uploaded.',
  },
};
_vc.KB_CRAWL_STATUS = {
  ACTIVE: 'ACTIVE',
  COMPLETE: 'COMPLETE',
  ERROR: 'ERROR',
  PARTIAL: 'PARTIAL',
};
_vc.KBR_SPLITTING_METHOD = {
  NAIVE: 'NAIVE',
  NLTK: 'NLTK',
  RECURSIVE: 'RECURSIVE',
  SEMANTIC: 'SEMANTIC',
  SPACY: 'SPACY',
};
_vc.KBR_PARSING_METHOD = {
  FIRECRAWL: 'FIRECRAWL',
  LLAMAPARSE: 'LLAMAPARSE',
  MARKDOWNIFY: 'MARKDOWNIFY',
  NATIVE: 'NATIVE',
  SPIDERWEB: 'SPIDERWEB',
};
_vc.KBR_CHUNK_SIZE = 1300;
_vc.BRAIN_STATUSES = {ACTIVE: 'ACTIVE', HISTORY: 'HISTORY', INIT: 'INIT'};
_vc.BRAIN_GOALS_AND_OBJECTIVES = {
  CALL: 'CALL',
  SCHEDULING: 'SCHEDULING',
  ANSWERING: 'ANSWERING',
};
_vc.LLM_MODEL_TYPES = {
  OPEN_AI: 'OPEN_AI',
  CLAUDE: 'CLAUDE',
  LLAMA_2: 'LLAMA_2',
  GEMINI: 'GEMINI',
};
_vc.EMBEDDING_MODEL_TYPES = {
  OPEN_AI: 'OPEN_AI',
  HUGGINGFACE: 'HUGGINGFACE',
  GEMINI: 'GEMINI',
};
_vc.BRAIN_OWNER_OBJECT_TYPES = {
  WIDGET: 'WIDGET',
  MENTOR: 'MENTOR',
  TEAM_MENTOR: 'TEAM_MENTOR',
};
_vc.PROTECTED_BRAIN_FIELDS = [
  'brainId',
  'ownerObjectId',
  'status',
  'vectorDbCollectionName',
  'creationTime',
];
_vc.BRAIN_PROMPT_UI_LANGUAGES = {
  ENGLISH: 'ENGLISH',
  SPANISH: 'SPANISH',
  FRENCH: 'FRENCH',
  GERMAN: 'GERMAN',
  DUTCH: 'DUTCH',
  HEBREW: 'HEBREW',
  ITALIAN: 'ITALIAN',
  AZERBAIJANI: 'AZERBAIJANI',
};
_vc.BRAIN_TONES_OF_VOICE = {
  FORMAL: 'FORMAL',
  INFORMAL: 'INFORMAL',
  FRIENDLY: 'FRIENDLY',
  PROFESSIONAL: 'PROFESSIONAL',
};
_vc.BRAIN_MODEL_TYPE = {
  LLM: 'LLM',
  EMBEDDING: 'EMBEDDING',
};
_vc.BRAIN_PROMPT_TYPE = {
  CHAT_COMPLETION: 'CHAT_COMPLETION',
  SUMMARIZATION: 'SUMMARIZATION',
};
_vc.PRELOAD_DELAY = 8000;
_vc.LAZY_LOADED_COMPONENTS = {
  EMOJI_MART_DATA: 'EMOJI_MART_DATA',
  EMOJI_MART_REACT: 'EMOJI_MART_REACT',
  MOMENT: 'MOMENT',
  OT_VIDEO_COMPONENT: 'OT_VIDEO_COMPONENT',
};
_vc.ANIMATED_SVG_LOGO_TYPES = {
  MESSENGER: 'MESSENGER',
  WHATSAPP: 'WHATSAPP',
  PHONE_CALL: 'PHONE_CALL',
  CUSTOM_LINK: 'CUSTOM_LINK',
};
_vc.TEST_ENV_NAMES = {
  ILAN_LOCAL: 'ILAN_LOCAL',
  JASHAN_LOCAL: 'JASHAN_LOCAL',
  MANPREET_LOCAL: 'MANPREET_LOCAL',
};

export default _vc;
